export default {
    VIETNAMESE: "Tiếng việt",
    ENGLISH: "English",
    JAPANESE: "日本語",
    KOREAN: "한국어",
    CHINESE: "中文",
    LAO: "ພາສາລາວ",
    KHMER: "ភាសាខ្មែរ",
    SYNC: "Sync",
    PLEASE_SELECT_DATE_LESS_6_MONTH: "Please select a date range less than or equal to 6 months",
    CHAIN_DASHBOARD_INFO: "Chain",
    CHAIN_DASHBOARD: "Chain Dashboard",
    BOOKING_DASHBOARD: "Boooking Dashboard",
    USE_HOTEL: "Use Hotel",
    CANCEL_SUCCESS: "Update success",
    BOOKING_PAID: "Paid",
    BOOKING_CANCELED: "Booking cannot be cancelled, please review the status",
    LOCATION_IS_NOT_EXIST: "Location is not exist",
    ROOM_AVAILS_INCORRECT: "The value of vacant rooms cannot be greater than the total number of rooms declared",
    PROMOTION_NULL: "Promotion does not exist",
    CANCLE_FAILE: "Cancle fail",
    DELETE_FAILE: "Delete fail",
    GROUP_USED: "User group is being used",
    TRANSDATE_INCORRECT: "The payment date must be between the booking date and the check-out date",
    AMOUNT_INCORRECT: "Incorrect payment amount",
    HAS_NO_DATA: "No data available",
    LOCATION_NOT_EXIST: "Location does not exist",
    UPDATE_SUCCESS: "Update successfully",
    UPDATE_CUCCESS: "Update successfully",
    DELETE_SUCCESS: "Delete successfully",
    CREATE_SUCCESS: "Create successfully",
    REGISTER_SUCCESS: "Register successfully",
    UPLOAD_SUCCESS: "Update successfully",
    PROMOTIONS_ARE_BEING_USED: "Promotions are being used",
    PROMOTIONS_DO_NOT_BELONG_TO_HOTELS: "Promotions do not belong to hotels",
    COUNPON_EXIST: "Coupon exist",
    USER_IS_EXIST: "Username is existed",
    EMAIL_USER_IS_EXIST: "Email is existed",
    EMAIL_HOTEL_IS_EXIST: "Email is existed",
    ACCOUNT_IS_TAKEN: "Username is taken",
    USER_NAME_OR_EMAIL_IS_EXISTED: "Username or email is existed",
    CANNOT_FIND_SOURCE: "Cannot find source",
    IMAGE_CAPACITY_NOT_BIGGER_THAN: "Maximum upload image size:",
    FILE_CAPACITY_NOT_BIGGER_THAN: "Maximum upload file size:",
    IMAGE_SIZE_NOT_BIGGER_THAN: "Photo has a minimum size",
    INVALID_IMAGE_FORMAT: "Invalid image format",
    INVALID_FILE_FORMAT: "Invalid file format",
    DELETE_FAIL: "Delete fail",
    IMAGE_MAIN_EMPTY: "Image main empty",
    ROOM_EMPTY: "Room empty",
    ROOM_IS_SELECTING: "Room is selecting",
    NOT_SELECTED_PROMOTION: "No promotion is selected",
    MISSING_FIELD: "PLEASE ENTER FULL Necessary INFORMATION",
    CONFIRM_DELETE_PHOTOS: "Confirm delete photo",
    MAIN_IMAGES_MUST_EXIST: "Main photo must exist",
    CONFIRM_DELETE_POLICY: "Confirm delete policy",
    CONFIRM_DELETE_SALE_PACKAGE: "Confirm delete this sale room package",
    CONFIRM_DELETE_PROMOTION_PACKAGE: "Confirm delete this promotion package",
    CONFIRM_DELETE_ROOM: "Confirm delete room",
    UPLOAD_EXPIRED: "Upload Expired",
    PAYMENT_METHOD_HAS_NOT_SELECTED: "Payment method is not selected",
    SETTING_GATEWAY_EMPTY: "Gateway setting is not existed",
    DEPOSIT_COMPARE_PAYMENT: "The payment due date cannot be greater than the deposit payment term",
    TIP_MAIN_IMAGE: "Hotel avatar is the first photo. Drag and drop photos to change the display order",
    TIP_MAIN_ROOM_IMAGE: "Room avatar is the first photo. Drag and drop photos to change the display order",
    CUSTOMER_PACKAGE_NOT_BIGGER_THAN_ROOM: "The total number of applicable guests of the package cannot be greater than the maximum number of guests in the room",
    FIELD_NUMBER_FORMAT: "Only numeric characters are allowed, no spaces",
    FIELD_POSITIVE_FORMAT: "Only positive integers, no spaces are allowed",
    FIELD_DISTANCE_FORMAT: "Only numeric characters, dots (.), no spaces are allowed",
    CHAIN_NAME_EMPTY: "Chain name empty",
    USER_IS_NOT_EXIT: "User is not existed",
    USER_IS_NOT_EXIST: "User is not existed",
    HOTEL_WAS_IN_CHAIN: "Hotel is being in chain",
    DESCRIPTION_INFO: "Description",
    REQUIRED: "*",
    SELECT_ALL: "Select all",
    IMAGES: "Photos",
    HOTEL_PHOTO: "Hotel photos",
    LIBRARY: "Gallary",
    ADD_NEW: "Create",
    AND: "and",
    BACK: "Back",
    SAVE: "Save",
    EDIT: "Edit",
    DELETE: "Delete",
    COPY: "Copy",
    POLICY: "policy",
    ALWAYS: "Always",
    IN_PERIOD: "Period",
    GENERAL_SETTING: "General Setting",
    PAYMENT_POLICY: "Payment policies",
    CANCELATION_POLICY: "Cancellation policies",
    PAY_GATE: "Payment gate",
    AGENT_STOP_CONNECT: "Agent stop connect",
    WARNING_METHOD: "Warning method",
    ALERT_RECEIVING_METHOD: "Warning Method",
    SELECT_WARNING_METHOD: "Select warning method",
    WARNING_QTY_ROOM: "Notice when the room number reach set up threshold",
    SETTING_WARNING_ROOM: "Sending notice when the room number reach set up value",
    SEND_WARNING_ANY_ROOM: "Sending notice when any roomtype reach set up room number less than set up value",
    SEND_WARNING_ROOM: "Sending notice when the room number reach set up value",
    ALERT_RECEIVING_METHOD: "Warning Method",
    SELECT_WARNING_METHOD: "Select warning method",
    WARNING_QTY_ROOM: "Notice when the room number reach set up threshold",
    SETTING_WARNING_ROOM: "Sending notice when the room number reach set up value",
    SEND_WARNING_ANY_ROOM: "Sending notice when any roomtype reach set up room number less than set up value",
    SEND_WARNING_ROOM: "Sending notice when the room number reach set up value",
    QTY_ROOM_LESS_THAN: "Fewer rooms",
    HOTEL_WARNING: "Warning method",
    SETTING_AT_LEAST_1_ROOM: "Please select at least 1 roomtype to perform set up the warning  threshold",
    HOTEL_WARNING: "Warning method",
    SETTING_AT_LEAST_1_ROOM: "Please select at least 1 roomtype to perform set up the warning  threshold",
    REGISTER_INFO: "Register information",
    EXTENSION: "Amenities",
    NEARBY_PLACE: "Nearby place",
    HOTEL_CHAIN: "Hotel chain",
    HOTEL_REGISTER_INFO: "Hotel register information",
    HOTEL_CODE: "Hotel code",
    STAR_RATING: "Star",
    HOTEL_LOGO: "Logo",
    CONTACT_PHONE: "Phone number",
    HOTEL_TYPE: "Hotel type",
    COUNTRY: "Country",
    CITY: "Province/ City",
    DISTRICT: "Ward / Commune / Special Zone",
    WARD: "Ward",
    HOTEL_NAME: "Hotel name",
    ADDRESS: "Address",
    MAP_LOCATION: "Location on the map",
    LONGITUDE: "Longitude",
    LATITUDE: "Latitude",
    DASHBOARD: "Dashboard",
    MANAGE: "Manage",
    BOOK_ROOM: "Book room",
    ROOM_SALE: "Room sale",
    ROOM_AVAILABLE_AND_PRICE: "Inventory and rate",
    SALE_AND_PROMOTION_PACKAGES: "Sale and promotion packages",
    SETTING: "Setting",
    ACCOUNT_INFO: "Account configuration",
    ACCOUNT_SETTING: "Personal account",
    USER_MANAGE: "User management",
    CONTRACT: "Contract",
    HOTEL_INFOMATION: "Hotel configuration",
    GENERAL_INFO: "General setting",
    TYPE_ROOM: "Room type",
    HOTEL_CONFIG: "Configuration",
    GALLERY_MANAGER: "Photo gallery",
    TRAVEL_AGENT: "Travel agency",
    ACTIVITY_DAIRY: "System log",
    ACTIVITY_DIARY_UPDATE_BULK: "Diary log update bulk",
    ACTIVITY_DIARY_UPDATE_ROOM_AVAIL: "Diary log update inventory",
    SUPPORT: "Support",
    INSTRUCTION_DOCUMENT: "Instruction document",
    INSTRUCTION_DOCUMENT_CONNECT_BE: "Website integration",
    COPYED: "Has copied",
    VIEW_DEMO: "View page Booking Engine",
    HOTLINE: "Hotline",
    BOOKING_LIST: "Booking",
    REQUEST_BOOKING_LIST: "Request Booking",
    REVENUE_AND_EXPENDITURE_TRANSACTION: "Transaction",
    AGENT_LIST: "List of agents",
    UNLINKED_LIST: "Agents stop working",
    PREVIEW_ON_BE: "Booking engine link",
    PREVIEW_ON_TA: "View page TA",
    SALE_CHANNEL: "Channel",
    CHANNEL_GROUP: "Channel group",
    SUNDAY: "Sunday",
    MONDAY: "Monday",
    TUESDAY: "Tuesday",
    WEDNESDAY: "Wednesday",
    THURSDAY: "Thursday",
    FRIDAY: "Friday",
    SATURDAY: "Saturday",
    _DATE_RANGE: {
        SUNDAY: "SUN",
        MONDAY: "MON",
        TUESDAY: "TUE",
        WEDNESDAY: "WED",
        THURSDAY: "THU",
        FRIDAY: "FRI",
        SATURDAY: "SAT",
        JAN: "January",
        FEB: "February",
        MAR: "March",
        APR: "April",
        MAY: "May",
        JUN: "June",
        JUL: "July",
        AUG: "August",
        SEP: "September",
        OTC: "October",
        NOV: "November",
        DEC: "December"
    },
    _PAYGATE: {
        PAYMENT_THROUGH: "Payment through",
        PAYMENT_METHOD: "Payment methods",
        ONLINE_PAYMENT_GATEWAY: "Online payment gateway",
        CONFIGURATION: "Configuration",
        CONFIG_PAYMENT_GATE: "Payment gateway configuration",
        HOTEL: "Hotel",
        TRANSFER_PAYMENT: "Transfer payments",
        ONLINE_PAYMENT: "Online payments",
        PAYMENT_TYPE_EMPTY: "No payment type exists",
        PAYMENT_METHOD_HAS_NOT_SELECTED: "Payment method not selected",
        PAYMENT_GATEWAY_IS_NOT_EXIST: "Online payment gateway is not selected",
        CASH: "Cash Payment",
        DEBT: "Debt settlement",
        PAYMENT_CARD: "Payment card"
    },
    NEAREST_POPULAR_LOCATION: "Nearest popular place",
    MOST_POPULAR_LOCATION: "The most popular place",
    RESTAURANT_AND_MARKET: "Restaurant and market",
    TRAVEL_PLACE: "Tourist attraction",
    NEAREST_AIRPORT: "Nearest airport",
    VIETNAMESE_NAME: "Vietnamese name",
    ENGLISH_NAME: "English name",
    ADD_LOCATION: "Add location",
    DISTANCE: "Distance",
    ROOM_INFOMATION: "Room information",
    ROOM_AMENITIES: "Room amenities",
    ROOM_IMAGE: "Room photos",
    ROOM_NAME: "Room type",
    ROOM_TYPE: "Room type",
    MEAL: "Meal",
    NAME_ROOM_TYPE: "Room type name",
    NAME_ROOM_TYPE_DEFAULT: "Title (default)",
    TOTAL_ROOM: "Number of rooms",
    MAX_CUSTOMER_COUNT: "Maximum guests",
    ROOM_DIMENSION: "Room size",
    BED_BONUS_COUNT: "Number of extra beds",
    PRICE_NORMAL_DAY: "Weekdays prices",
    PRICE_WEEKEND: "Weekend prices",
    ROOM_DIRECTION: "Direction of room",
    BED_TYPE: "Bed type",
    ADULT: "Adult",
    CHILDREN: "Children",
    ACTION: "Action",
    COMMON_BED_TYPE: "Common bed type",
    COMBINATION_BED_TYPE: "Bed type combination",
    MORE_OPTIONS: "More option",
    REMOVE_OPTIONS: "remove the option",
    ADD_TYPE_BED: "Add bed type",
    FREE: "Free",
    SURCHARGE: "Surcharge",
    PACKAGE: "package",
    SELLING_PACKAGE_INFO: "Rate plan information",
    SELLING_PACKAGE: "Rate plan",
    SERVICE_PACKAGE: "Benefit package",
    PROMOTION: "Promotion",
    PROMOTION_INFO: "Promotion information",
    NAME_SELLING_PACKAGE: "Rate plan name",
    PACKEAGE_APPLY_FOR: "Sales package applies to",
    MEALS_INCLUDE: "Meals included",
    EXTRA_BED_PRICE: "Extra bed rate",
    EXTRA_ADULT_PRICE: "Extra adult rate",
    EXTRA_CHILD_PRICE: "Extra child rate",
    MIN_NIGHT: "Minimum number of nights",
    MAX_NIGHT: "Maximum number of nights",
    DAYS_NOT_APPLY: "Blackout date",
    NOT_APPLY: "Blackout date",
    ADD_DAYS_NOT_APPLY: "Additional dates do not apply",
    TYPE_ROOM_APPLIED: "Room type applicable",
    PLAN_IS_SELECTING: "Sale package has been connected to OTA",
    PLAN_NULL: "Rate plan does not exist",
    ERROR: "Sorry, an unexpected error has occurred. Please try again later.",
    COPY_SUCCESS: "Copy success",
    COPPY_SUCCESS: "Copy success",
    NOT_SELECTED_PLAN: "No rateplans have been selected",
    NOT_SELECTED_ROOM: "No rooms have been selected",
    MAX_STAY_NOT_SMALL_THAN_MIN_STAY: "Maximum number of nights cannot be smaller than minimum number of nights",
    CBALERT_LB_AVAISEARCH: "Select one or more",
    PROMOTION_PACKAGE_NAME: "Promotion name",
    PROMOTION_TYPE: "Promotion type",
    APPLY: "Apply",
    APPLY_WITH: "Apply with",
    DISCOUNT_AND_SURCHARGES: "Discount/Surcharge rate",
    DAYS_APPLY: "Days of week",
    TIME_STAY: "Staying date",
    TIME_SET: "Booking date",
    TARGET_APPLY: "Subject of application",
    ARGENT_LEVEL_APPLY: "Select the agent level",
    ARGENT_APPLY: "Select the agent",
    PACKAGE_APPLY: "Rate plan",
    X_DAYS: "x days",
    FROM_DATE: "From",
    TO_DATE: "To",
    MIN_COUNT: "Minimum quantity",
    NIGHT_STAY: "Number of nights",
    ROOM_BOOK_QUANTITY: "Number of rooms",
    QUANTITY_IS_FREE: "Free quantity (y)",
    COUPON: "Coupon",
    STATUS: "Status",
    ACTIVE: "Active",
    DEACTIVE: "Inactive",
    STATE_ACTIVE_OR_DEACTIVE: "Active/Inactive",
    CONTACT_BOOKING_DETAIL: "Contact details",
    BOOKING_DETAIL: "Booking details",
    NORMAL_ROOM_DETAIL: "Basic room details",
    VIP_ROOM_DETAIL: "VIP room details",
    SERVICES: "Service",
    PAYMENT_HISTORY: "Payment history",
    FILE_NAME: "File name",
    FILE_TYPE: "File type",
    UPLOAD_BY: "Upload by",
    FILE_CAPACITY: "File capacity",
    SIZE: "Size",
    UPLOAD_TIME: "Upload time",
    CLOSE: "Close",
    TOTAL: "Total",
    OR: "or",
    CHOOSE: "Choose",
    NO_PHOTOS_FOUND: "No photos found",
    DRAG_DROP_PHOTOS_HERE: "Drag and drop photos here",
    SELECT_PHOTOS_TO_UPLOAD: "Select photos to upload",
    MAXIMUM_CAPACITY: "Maximum capacity",
    LOADING: "Loading",
    EMAIL_CONFIGURATION: "Email setting",
    HOTEL_EMAIL: "Hotel email",
    EMAIL_RECEIVE_BOOKING_ALERT_CC: "Notification Email",
    EMAIL_CO_RECEIVE_BOOKING_ALERT_CC: "Notification Email (cc email)",
    EMAIL_RECEIVE_BOOKING_ALERT_BCC: "Notification Email (bcc email)",
    DISPLAY_LANGUAGE_AND_WEEKEND: "Display language and weekend",
    DISPLAY_LANGUAGE: "Language",
    WEEKEND: "Weekend",
    CURRENCY_AND_TAXES_FEES: "Currency and taxes/surcharges",
    CURRENCY_USED_IN_SYSTEM: "Currency",
    VAT_RATE_IS_APPLIES: "VAT%",
    SERVICE_TAX_RATE_APPLIES: "The service charge",
    PRICES_INCLUDE_TAXES_FEES: "Prices include taxes/surcharges",
    REGULATIONS_ON_CHILD_AGE_AND_ACCOMPANING_FEE: "Regulations on child age and accompanying fee",
    YOUTH_IS_FREE_OF_CHARGE: "Maximum age of baby",
    AGE_CHILD_EXTRA_CHARGE: "Maximum age of children",
    OTHER_INFOMATION: "Other information",
    CHECKIN_TIME: "Check-in time",
    CHECKOUT_TIME: "Check-out time",
    YEAR_BUILT: "Year built",
    TOTAL_NUMBER_OF_FLOORS: "Number of floors",
    DISTANCE_TO_AIRPORT: "Distance to airport",
    DISTANCE_TO_CITY_CENTER: "Distance to city center",
    TIME_TO_AIRPORT: "Time to airport (minutes)",
    VOLTAGE_USED: "Voltage used",
    ROOM_SERVICE: "Room service",
    HOTEL_RULES: "Hotel Policies",
    EFFECTIVE_DATE: "Effective date",
    DEPOSIT_BEFORE_CHECKIN: "Deposit before check-in date",
    PERCENT: "Percent",
    AMOUNT_OF_MONEY: "Amount",
    PREPAYMENT_BEFORE_CHECKIN_DATE: "Payment before check-in date",
    PAYMENT_BEFORE_CHECKOUT_DATE: "Payment on check out date",
    PAYMENT_BEFORE_DAY_CHECKIN_DATE: "Payment on check-in date",
    ADD_NEW_PAYMENT_POLICY: "Add new payment policy",
    DEPOSIT_LEVEL_APPLIES: "Deposit level applies",
    TIME_APPLICATION: "Staying date",
    CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE_CHECKIN: "Cancel booking within x days before checkin date",
    FIXED_MONEY: "Fixed amount of money",
    ADD_NEW_CANCELLATION_POLICY: "Add new cancellation policy",
    FINES_APPLY: "Fines apply",
    PERSONAL_ACCOUNT_SETTING: "Personal account settings",
    LOG_OUT: "Log out",
    FEEDBACK_SUCCESS: "Feedback success",
    _LOGIN: {
        LOGIN: "Login",
        USERNAME: "Username",
        PASSWORD: "Password",
        FORGOT_PASSWORD: "Forgot password",
        REGISTER_NOW: "Register now",
        LOOKING_AGENT: "Looking for the Agent?",
        LOGIN_HERE: "Login here",
        INVALID_ACCOUNT_INFO_MESSAGE: "Username or password is incorrect!",
        SESSION_EXPIRED: "Your session has expired!",
        HAS_NO_ACCESS: "Login account is not valid!",
        SESSION_EXPIRED_MESSAGE: "For security reasons, this session expires after  period of time with no activity. To continue,  enter your username and password and login.",
        ARE_YOU_FORGOT_PASSWORD: "Do you forgot password?",
        ENTER_EMAIL_USERNAME: "Please enter your email or username to receive email reset your password!",
        EMAIL_USERNAME: "Email or Username",
        EMAILADDRESS_ERROR_REQUIRED: "Please check your email again!!",
        EMAIL_NOT_EXIST: "Your email or username is not exist, Please try again!",
        REQUEST_RESET_PASS_NOTICE: "Your request reset password is succeed",
        SEND_NEW_PASS: "New password has been sent, please check your email!",
        CANCEL: "Cancel",
        RESET: "Confirm",
        HOTELID: "Hotel id",
        EZID_LOGIN: "Login with ezID"
    },
    _RESET: {
        NOT_VALID_REQUEST: "Your reset request is no longer valid"
    },
    _REGISTER: {
        OTA_GROUP: "Sell channel group",
        OTA: "Sell channel",
        WELCOME: "Welcome to ezCrs - Especially designed for our Hotels",
        SOLOGAN: "Get registered with us today & we will assist you all the way from start to end. You can book various range of products with us & sell to your customers. Join with us right now!!!",
        PERSONAL_DETAIL: "Personal details",
        HOTEL_DETAIL: "Hotels details",
        CREATE_ACCOUNT: "Create account",
        ENTER: "Enter",
        HOTEL_EMAIL: "Hotel email",
        ENTER_EMAIL: "Enter email",
        ENTER_TAX_CODE: "Enter code",
        ENTER_ROOM_QUANTITY: "Enter room quantity",
        YOUR_COMPANY_NAME: "Your company/brand name",
        YOUR_WEBSITE_LINK: "Your hotel website link",
        SELECT: "Select",
        REQUIRED: "Required",
        FULLNAME: "Fullname",
        YOUR_FULLNAME: "Your full name",
        PERSONAL_PHONE: "Personal phone number",
        MALE: "Male",
        FEMALE: "Female",
        EMAIL: "Email",
        YOUR_EMAIL: "Your email",
        POSITION: "Position/Title",
        YOUR_POSITION: "Your Position/Title",
        HOTEL_NAME: "Hotel name",
        HOTEL_TYPE: "Hotel type",
        TAX_CODE: "Tax code",
        COUNTRY: "Country",
        WARD: "Ward",
        WEBSITE: "Website",
        STAR: "Stars",
        CITY: "City/Province",
        ADDRESS: "Address",
        HOTEL_PHONE: "Hotel phone number",
        NUMBER_OF_ROOMS: "Number of rooms",
        DISTRICT: "Ward/Commune/Special Zone",
        USERNAME: "Username",
        CREATE_NEW_ACCOUNT_NAME: "Create New Account Name",
        PASSWORD: "Password",
        CREATE_PASSWORD: "Create password",
        RETYPE_PASSWORD: "Re-type Password",
        PASSWORD_NOT_MATCH: "Password doesn't match",
        PHONE_NUMBER_NOT_LESS_THAN: "Phone number cannot be less than 8 characters",
        PASSWORD_NOT_LESS_THAN: "Password cannot be less than 8 characters",
        VALID_USERNAME_MESSAGE: "Choose a username that contains only letters and numbers",
        BY_CLICKING_REGISTER: "By Clicking Register, you agree to our",
        TERM_AND_CONDITIONS: "Term and Conditions",
        PRIVACY_POLICY: "Privacy Policy",
        AGREE_POLICY_MESSAGE: "By Clicking Register, you agree to our Term and conditions & Privacy Policy",
        THANKS_FOR_REGISTER: "Thank you for Registering!",
        WAIT_APPROVE: "Your account has created and waiting approve.",
        UPLOAD_CERTIFICATE_MESSAGE: "Please upload the Business registration certificate to help us verify and issue the account. We will confirm your account within 48hours.",
        REQUIRED_FIELD: "Mandatory",
        ACCOUNT_ALREADY_EXISTS: "Account already exists",
        REGISTER: "Register",
        NEXT: "Next",
        BACK: "Back",
        UPLOAD_FILE: "Upload Files",
        COMPLETE_AND_LOGIN: "Complete and back to Homepage"
    },
    _SUPPORT: {
        TITLE: "Instructions for integrating Booking Engine into the website"
    },
    _DASHBOARD: {
        TITLE: "Dashboard",
        IN_MONTH_REVENUE: "This month's revenue (VND)",
        SEVEN_DAY_REVENUE: "Last 7 days revenue (VND)",
        COLLECTION: "Receivables (VND)",
        ROOM_FILLING_RATE: "Room occupancy rate on month",
        BOOKING_EMPTY: "New reservations will appear here",
        BOOKING_TIME: "Booking time",
        BOOKING_CODE: "Booking code",
        AGENCY: "Agency",
        TIME_STAY: "Stay date",
        PACKAGE: "Subscription packages",
        TOTAL: "Total (VND)",
        PAYMENT_STATUS: "Payment status",
        BOOKING_NOT_PAYMENT: "Unpaid booking",
        BOOKING_PART_PAYMENT: "Booking partially paid",
        BOOKING_CANCELED: "Booking is cancelled by the customer",
        GO_TO_BOOKING_LIST: "See full Booking",
        STATUS: "Status",
        HOTEL_STATUS: "Hotel information",
        CONTRACT: "Contract",
        DEBT: "Liabilities",
        SYNC_PMS: "Sync PMS",
        MISSING_INFO: {
            SYNC_OTA: "Channel sync",
            SYNC_OTA_SUB_TITLE: "Minimum 1-channel sync OTA",
            LIMITATIONS: "Declare restrictions",
            RESTRICTION_SUB_TITLE: "Declare at least a restriction",
            RATE_PLAN: "Declare the price, room inventory",
            RATE_PLAN_SUB_TITLE: "Declare the minimum value for 1 channel and room inventory",
            TITLE: "Complete the required information",
            HOTEL_INFO: "Hotel information",
            HOTEL_INFO_SUB_TITLE: "Fill out the required fields",
            ROOM_TYPE: "Room type information",
            ROOM_TYPE_SUB_TITLE: "Declare at least 1 room type",
            HOTEL_IMAGE: "Hotel photos",
            HOTEL_IMAGE_SUB_TITLE: "Upload at least 1 image",
            ROOM_PRICE: "Rate plan",
            ROOM_PRICE_SUB_TITLE: "Declaring at least 1 rate plan",
            HOTEL_SETTING: "Hotel setting",
            HOTEL_SETTING_SUB_TITLE: "Fill out the required fields",
            BOOKING_CANCEL_POLICY: "Cancellation policies",
            BOOKING_CANCEL_POLICY_SUB_TITLE: "Declaring at least 1 policy",
            PAYMENT_GATE: "Payment gateways",
            PAYMENT_GATE_SUB_TITLE: "At least 1 payment method",
            CONTRACT: "Contract",
            CONTRACT_SUB_TITLE: "Fill out the required fields",
            PAYMENT_POLICY: "Payment policies",
            PAYMENT_POLICY_SUB_TITLE: "Declaring at least 1 policy",
            CLOSE: "Closed",
            ROOM_PLAN: "Rate plan",
            ROOM_PLAN_SUB_TITLE: "Declare at least 1 room sales package",
            HOTEL_CONFIG: "Hotel configuration",
            HOTEL_CONFIG_SUB_TITLE: "Fill out the required fields"
        },
        CONFIRM: "Confirm",
        CONFIRM_SELL_ROOM: "I agree that all information entered is absolutely accurate and agree to post a room for sale on OneInventory",
        CONFIRM_SELL_ROOM_BUTTON: "Room for sale confirmation",
        _HOTEL_STATUS_INFO: {
            CREATE: "Create",
            WAIT_CONFIRM: "Wait confirm",
            WAIT_APPROVE: "Wait approve",
            APPROVED: "Approved",
            SENT_BACK: "Sent back",
            ONSITE: "Onsite",
            OFFSITE: "Offsite"
        },
        _HOTEL_STATUS_CONTRACT: {
            NOT_CREATED: "Not created",
            CREATE: "Create",
            RELEASED: "Released",
            WAIT_SIGN: "Wait for sign",
            COMPLETED: "Complete",
            SIGNED: "Signed",
            IN_DISPUTE: "In dispute",
            LIQUIDATED: "Liquidated",
            CLOSED: "Closed"
        },
        _HOTEL_STATUS_DEBT: {
            NOT_CONFIGURED: "Not configured",
            CONFIGURED: "Configured"
        },
        _HOTEL_STATUS_SYNC_PMS: {
            SYNCHRONIZED: "Synchronized",
            UNSYNCHRONIZED: "Unsynchronized",
            RECEIVED: "Received",
            NOT_RECEIVED: "Not yet received"
        }
    },
    _BATCH_UPDATE: {
        TITLE: "Bulk update",
        ADD: "Add",
        SELECT_ROOM_TYPE: "Choose a room type",
        SELECT_UPDATE_TYPE: "Choose update",
        ALL_ROOM: "All rooms",
        AVAILABLE_ROOM: "Inventory",
        PRICE: "Price",
        STOP_SELL: "Stop selling",
        CTA: "Close to arrival",
        CTD: "Close to departure",
        MIN_NIGHT_STAY: "Minimum number of nights",
        MAX_NIGHT_STAY: "Maximum number of nights",
        ROOM_TYPE_AND_SALE_PACKAGE: "Room type / Rate plan",
        FROM: "From",
        TO: "To",
        MESSAGE: {
            OVERLAP_TIME: "Update intervals cannot overlap"
        },
        APPLY: "Apply",
        DELETE_STOP_SELL: "Delete stop selling",
        DELETE_CTA: "Delete close to arrival",
        DELETE_CTD: "Delete close to departure"
    },
    _BOOKING: {
        TITLE: "Booking list",
        BOOKING: "0 booking | 1 booking | {count} bookings",
        BOOKING_DATE: "Booking date",
        BOOKING_CODE: "Booking code",
        REQUEST_CODE: "Request code",
        REQUEST_DATE: "Request date",
        REQUEST_STATUS: "Request status",
        AGENT_NAME: "Agency",
        TIME_STAY: "Staying date",
        COMBO: "Subscription packages",
        COMBO_REQUEST: "Request package",
        AMOUNT: "Total Amount",
        BOOKING_STATUS: "Booking status",
        EXPORT: "Excel export",
        SEARCH: "Search",
        RESET: "Reset",
        ENTER_BOOKING_CODE: "Enter booking code",
        ENTER_BOOKING_CODE_OTA: "Enter OTA booking code",
        ENTER_BOOKING_GROUP_CODE: "Enter group booking code",
        SEARCH_CONDITION: "Search by",
        SEARCH_BOOKING_CODE: "Booking code",
        SEARCH_DATE: "Choose a date range",
        EDIT: "Manipulation",
        CONFIRM_FEEDBACK: "Confirm sent request to the agent",
        CONFIRM_FEEDBACK_REASON: "Feedback content",
        SEARCH_BY: {
            BOOKING_CODE: "Booking code",
            REQUEST_DATE: "Request date",
            BOOKING_DATE: "Booking date",
            CHECKIN_DATE: "Check-in date",
            CHECKOUT_DATE: "Check-out date",
            STAYING_DATE: "Staying date"
        },
        STATUS: {
            ALL: "All",
            CANCEL: "Cancelled by customer",
            AWAIT_PAYMENT: "Waiting for payment",
            CLOSE: "Closed",
            IN_SERVICE: "In service",
            PAYMENT_FAILED: "Payment failed",
            CONFIRM: "Confirmed",
            AWAIT_FULLY_PAYMENT: "Partial payment",
            VOID: "Cancelled by hotel",
            STATUS_WAIT_FEEDBACK: "Wait for feedback",
            STATUS_FEEDBACK: "Feedback",
            STATUS_COMPLETE: "Completed",
            STATUS_CANCEL: "Cancelled"
        },
        SEARCH_PMS_STATUS: "Syns status",
        SEARCH_PMS_CODE: "PMS type",
        CHECKIN_STATUS: "Check-in Status",
        AGENT: "TA",
        MARKET: "Market segment",
        PDF: "PDF export",
        UNMAP_BOOKING: {
            UNMAP_BOOKING_TITLE: "Mapping status",
            ALL: "All",
            MAPPED: "Mapped",
            UNMAP_ROOM_TYPE: "Unmapped room",
            UNMAP_RATE_PLAN: "Unmapped rate",
            UNMAP_ROOMRATE: "Unmapped room_rate",
        }
    },
    _BOOKING_DETAIL: {
        TITLE: "Booking details",
        CONTACT: {
            TITLE: "Contact",
            NAME: "Guest name",
            PHONE: "Phone number",
            EMAIL: "Email",
            GROUP_NAME_TOUR: "Group name",
            AGENT_NAME: "Agent"
        },
        BOOKING_DETAIL: {
            TITLE: "Booking information",
            CODE: "Booking code",
            OTACODE: "OTA booking code",
            STATUS: "Booking status",
            CREATED: "Booking date",
            CHECK_IN: "Check-in date",
            CHECK_OUT: "Check-out date",
            UPDATED: "Updated date",
            NOTE: "Note"
        },
        ROOM: {
            TITLE: "Room details -",
            APPLY_DATE: "Date",
            NAME: "Rate plan",
            UNIT_PRICE: "Price / night (VND)",
            QUANTITY: "Number of rooms",
            ADULTS: "Adults",
            CHILDREN: "Children",
            BABY: "Infant",
            TOTAL: "Amount of money (VND)"
        },
        PROMOTION_ONEI: {
            TITLE: "Promotion One Inventory",
            NAME: "Promotion name",
            COST_TYPE: "Costs type",
            TOTAL: "Amount of money (VND)"
        },
        PROMOTION: {
            TITLE: "Promotion",
            NAME: "Promotion name",
            ROOM_PLAN_NAME: "Rate plan",
            ROOM_NAME: "Room type",
            TOTAL: "Amount of money (VND)"
        },
        SERVICE: {
            TITLE: "Service",
            NAME: "Service name",
            DATE: "Date usage",
            COST: "Price",
            COUNT: "Quantity",
            TOTAL: "Amount of money (VND)"
        },
        PAYMENT_LOG: {
            TITLE: "Payment history",
            METHOD: "Payments",
            AMOUNT: "Amount of money",
            TRANS_NO: "Trading code",
            TRANS_DATE: "Transaction date",
            RES_CODE: "Result",
            RES_MSG: "Note"
        },
        METHOD_NAME: {
            ONEPAY_DOM: "Domestic Onepay payment",
            ONEPAY_INTER: "International Onepay payment",
            VNPAY: "Vnpay payment",
            TRANSFER: "Transfer payment",
            CASH: "Cash payment",
            VNPAY_QR: "Vnpay QR payment",
            VIETTELPAY_QR: "Viettelpay QR payment",
            VIETTELPAY: "Viettelpay payment"
        },
        PAYMENT_CARD_DETAIL: "Payment card detail",
        SUB_TOTAL: "Sum",
        TOTAL: "Total Amount",
        PAID: "Paid amount:",
        UNPAID: "Outstanding amount:",
        EXPORT: "Print booking",
        CANCEL: "Cancel booking",
        NOTE: "Note",
        CONFIRM_CANCEL: "Confirm booking's cancellation?",
        CONFIRM_REASON: "Reason (required)",
        CONFIRM: "Confirm",
        COMMISSION: "Commission",
        BEFORE_COMMISSION: "Net amount received",
        AFTER_COMMISSION: "Price includes commission",
        PAYMENT_COLLECT: "Payment collect",
        PROPERTY_COLLECT: "Property collect",
        OTA_CONTACT: "OTA contact",
        CHANNEL_COLLECT: "Channel collect"
    },
    _REQUEST_DETAIL: {
        TITLE: "request details",
        BUGET: "Budget paid",
        CONTACT: {
            TITLE: "Booking contact details",
            NAME: "Guest name",
            PHONE: "Phone number",
            EMAIL: "Email",
            AGENT_NAME: "Agency",
            REQUESTER_NAME: "Requester name"
        },
        BOOKING_DETAIL: {
            TITLE: "Request details",
            CODE: "Request code",
            STATUS: "Request status",
            CREATED: "Request date",
            CHECK_IN: "Check-in date",
            CHECK_OUT: "Check-out date",
            UPDATED: "Update day"
        },
        ROOM: {
            TITLE: "Room details",
            APPLY_DATE: "Date",
            NAME: "Rate plan",
            UNIT_PRICE: "Price / night (VND)",
            QUANTITY: "Number of rooms",
            ADULTS: "Adults",
            CHILDREN: "Children",
            TOTAL: "Amount of money (VND)"
        },
        NOTE: "Note",
        SEND_REQUEST: "FeedBack"
    },
    _BOOKING_TRANSACTION: {
        TITLE: "Revenue and expenditure Transaction",
        ALL: "All",
        BOOKING: "book room",
        BOOKING_DATE: "Booking date",
        BOOKING_CODE: "Booking code",
        AGENT_NAME: "Agency",
        TIME_STAY: "Staying date",
        AMOUNT: "Total Amount",
        PAYMENT_DATE: "Payment date",
        BOOKING_STATUS: "Booking status",
        ACTION: "Action",
        EXPORT: "Excel export",
        SEARCH: "Search",
        CONFIRM: "Confirm",
        TIME_STAY_TEXT: "{day} day(s) {night} night(s)",
        SEARCH_CONDITION: "Search by",
        SEARCH_BOOKING_CODE: "Enter code",
        SEARCH_DATE: "Date range",
        SEARCH_BY: {
            BOOKING_CODE: "Booking code",
            BOOKING_DATE: "Booking date",
            CHECKIN_DATE: "Check-in date",
            CHECKOUT_DATE: "Check-out date"
        },
        STATUS: {
            CANCEL: "Cancelled by customer",
            AWAIT_PAYMENT: "Wait for payment",
            CLOSE: "Closed",
            IN_SERVICE: "In service",
            PAYMENT_FAILED: "Payment failed",
            CONFIRM: "Confirmed",
            AWAIT_FULLY_PAYMENT: "Partial payment",
            VOID: "Cancelled by hotel"
        }
    },
    _BOOKING_TRANSACTION_DETAIL: {
        TITLE: "Transaction details",
        DETAIL: "Transaction details",
        BOOKING_CODE: "Booking code:",
        PAYMENT_METHOD: "Payment method",
        TRANSACTION_CODE: "Transaction code",
        TRANSACTION_DATE: "Transaction date",
        AMOUNT: "Amount",
        NOTE: "Note",
        BANK_TRANSFER: "Transfer",
        CASH: "Cash",
        DEBT: "Debt"
    },
    _ROOM_PLAN: {
        TITLE: "Room and rate plan",
        BATCH_UPDATE: "Bulk update",
        ALL_ROOM: "All room",
        STOP_SELL: "Stop sell",
        MIN_STAY: "Min stay",
        MAX_STAY: "Max stay",
        CTA: "Close to arrival",
        CTD: "Close to departure",
        CURRENT_MONTH: "{month}/{year}",
        CONFIRM_CHANGE_PAGE: "Unsaved data will be lost\nDo you want to continues?",
        MIN_SMALLER_THAN_ONE: "Minimum night stay can't be smaller than 1",
        MAX_SMALLER_THAN_ONE: "Maximum night stay can't be smaller than 1",
        MIN_BIGGER_THAN_MAX: "Minimum night stay is bigger than maximum night stay",
        MIN_SMALLER_THAN_CONFIG: "Minimum night stay is smaller than config's minimum night stay",
        MAX_BIGGER_THAN_CONFIG: "Maximum night stay is bigger than config's maximum night stay"
    },
    SALE_PACKAGE: "Rate plan",
    _HOTEL_CHAIN: {
        CHAIN_LIST_HOTEL: 'Hotel',
        TITLE: "Hotel chain",
        CHAIN_NAME: "Chain name",
        CHAIN_LIST: "Hotel list ({total})",
        HOTEL_ID: "Hotel ID: ",
        ADD_HOTEL: "Add hotel",
        LOGIN_TEXT: "For chaning hotel, please login with the hotel's owner account",
        LOGIN_EXISTED_TEXT: "Account login {hotelName}:",
        USERNAME: "Username",
        PASSWORD: "Password",
        CONFIRM: "Confirm",
        REMOVE_HOTEL: "Are you sure to remove the selected hotel from the chain?",
        LOGIN: "Login",
        DELETE_HOTEL: "Remove from chain",
        LABEL_SEARCH_CODE_NAME: "Hotel code/ name",
        ENTER_HOTEL_NAME_OR_CODE: "Enter hotel name or hotel code",
        CHAIN_LIST_BOOKING: "Booking",
        STATUS: "Status",
        SEARCH: "Search"
    },
    _ACCOUNT_SETTING: {
        TITLE: "Personal account settings",
        AVATAR: "Avatar",
        USER_INFO: "Personal information",
        CHANGE_PASSWORD: "Change Password",
        USERNAME: "Username",
        FULLNAME: "Fullname",
        PASSWORD: "Password",
        PASSWORD_REPEAT: "Confirm password",
        GENDER: "Gender",
        GENDER_MALE: "Male",
        GENDER_FEMALE: "Female",
        EMAIL: "Email",
        PHONE_NUMBER: "Phone number",
        ADDRESS: "Address",
        POSITION: "Position",
        GROUP: "User groups",
        CURRENT_PASS: "Current password",
        NEW_PASS: "New password",
        NEW_PASS_REPEAT: "Repeat the new password",
        ERROR_PHONE_NUMBER_MIN: "Phone number must be at least 8 characters",
        ERROR_PASSWORD_MIN: "Password enter at least 8 characters",
        ERROR_RETYPE_PASSWORD_MIN: "Confirm password enter at least 8 characters",
        ERROR_PASSWORD_INVALID: "Incorrect current password",
        ERROR_PASSWORD_NOT_MATCH: "Password does not match",
        MESSAGE_PASSWORD_MATCHED: "Password is matched",
        MESSAGE_PASSWORD_NOT_MATCHED: "Password does not match"
    },
    _LIST_USER: {
        TITLE: "User management",
        LIST_USER: "User",
        USER: "user",
        SEARCH_PLACEHOLDER: "Search by username, full name or email",
        GROUP_NAME: "Group name",
        USERNAME: "Username",
        NAME: "Fullname",
        EMAIL: "Mail",
        CREATE_USER: "Create by",
        CREATE_DATE: "Create date",
        STATUS: "Status",
        ACTION: "Action",
        STATUS_ACTIVATE: "Active",
        STATUS_DEACTIVATE: "Inactive",
        REMOVE: "Confirm deletion of this user?",
        CANNOT_DELETE_CURRENT_USER: "Cannot delete current user"
    },
    _LIST_GROUP: {
        TITLE: "User group management",
        LIST_GROUP: "User group",
        GROUP: "user groups",
        SEARCH_PLACEHOLDER: "Search by user group name",
        GROUP_NAME: "Group name",
        CREATE_USER: "Create by",
        CREATE_DATE: "Create date",
        STATUS: "Status",
        ACTION: "Action",
        STATUS_ACTIVATE: "Active",
        STATUS_DEACTIVATE: "Inactive",
        DESCRIPTION: "Descriptive information",
        REMOVE: "Confirm deletion of this group?"
    },
    _EDIT_USER: {
        TITLE: "User information",
        INFO: "User information",
        USER: "User",
        ROLE: "Access rights",
        USERNAME: "Username",
        FULLNAME: "Fullname",
        PASSWORD: "Password",
        PASSWORD_REPEAT: "Confirm password",
        GENDER: "Gender",
        GENDER_MALE: "Male",
        GENDER_FEMALE: "Female",
        EMAIL: "Email",
        PHONE_NUMBER: "Phone number",
        ADDRESS: "Address",
        POSITION: "Position",
        GROUP: "User group",
        GROUP_PLACEHOLDER: "Search",
        HOTEL_OWNER: "Hotelier",
        STATUS: "Status active/Inactive",
        N_O: "STT",
        FUNCTION_CODE: "Function code",
        FUNCTION_NAME: "Function name",
        ACTION: "Action",
        ERROR_PHONE_NUMBER_MIN: "Phone number must be at least 8 characters",
        ERROR_PASSWORD_MIN: "Password enter at least 8 characters",
        ERROR_RETYPE_PASSWORD_MIN: "Confirm password enter at least 8 characters",
        ERROR_PASSWORD_NOT_MATCH: "Password does not match",
        CHAIN: "Chains",
        HOTEL: "Hotels"
    },
    _EDIT_GROUP: {
        TITLE: "User group information",
        INFO: "User group information",
        GROUP: "User group",
        ROLE: "Access rights",
        GROUP_NAME: "Group name",
        GROUP_CODE: "Group code",
        GROUP_ROLE: "Group role",
        PARENT_GROUP: "Parent group",
        TYPE: "Group type",
        DESCRIPTION: "Descriptive information",
        STATUS: "Status active/Inactive",
        NO: "STT",
        FUNCTION_CODE: "Function code",
        FUNCTION_NAME: "Function name",
        ACTION: "Action",
        ERROR_MIN_ROLE_SELECTED: "Please select at least 1 function screen"
    },
    _CONTRACT: {
        TITLE: "Electronic contract",
        CONTRACT_INFO: "Legal information",
        BUSINESS_NAME: "Company's name",
        BUSINESS_NAME_NOTE: " (Correctly fill in the business license, capital letters)",
        TAX_CODE: "Tax code",
        TAX_CODE_NOTE: " (Enter the correct and all zeros)",
        ADDRESS: "Registered business address",
        ADDRESS_NOTE: " (Fill in according to GPKD)",
        BANK_ACCOUNT: "Bank account number",
        BANK_ACCOUNT_OWNER: "Bank account onwner name",
        BANK: "Bank name",
        BANK_BRANCH: "Bank branch",
        LEGAL_REPRESENTATIVE: "Legal representative",
        LEGAL_REPRESENTATIVE_NOTE: " (Fill in according to GPKD)",
        PIC: "The person signing the contract",
        PIC_POSITION: "Signing position",
        COMMISSION: "Commission (%)",
        STATUS: "Contract status",
        VIEW: "View",
        _STATUS: {
            CREATE: "Create",
            AM_SENT: "AM Sent",
            SM_ACCEPT: "SM Accept",
            SM_REJECT: "SM Reject",
            CM_ACCEPT: "CM Accept",
            CM_REJECT: "CM Reject",
            PUBLISH: "Publish",
            WAIT_SIGN: "Wait for signing",
            COMPLETE: "Complete",
            SIGNED: "Signed",
            DISPUTED: "Disputed",
            LIQUIDFY: "Liquidfy",
            CLOSE: "Close",
            EXTEND: "Extend"
        }
    },
    _TRAVEL_AGENT: {
        TITLE: "Agency list",
        TITLE_DEACTIVE: "List of agencies that stop cooperating",
        AGENT: "agency",
        SEARCH_PLACEHOLDER: "Search by agency name",
        NAME: "Agency name",
        BUSINESS_TYPE: "Business type",
        TAX_CODE: "Tax code",
        LEVEL: "Classification agents",
        STATUS: "Status",
        DEACTIVE: "Unlink",
        ACTIVE: "Return to link",
        LEVEL_1: "Level 1",
        LEVEL_2: "Level 2",
        LEVEL_3: "Level 3",
        LEVEL_4: "Level 4",
        LEVEL_5: "Level 5",
        CONFIRM_CHANGE_LEVEL: "Confirm a level change?",
        CONFIRM_ACTIVE: "Confirm affiliation with agent?",
        CONFIRM_DEACTIVE: "Confirm agent unlink?",
        CONFIRM_REASON: "Reason (required)",
        CONFIRM: "Confirm"
    },
    _VALIDATE: {
        REQUIRED: "Please enter all necessary information",
        EMAIL_FORMAT: "Please check your email format",
        MIN_LENGTH: "The value entered must be more than {minLength} characters",
        MAX_LENGTH: "The value entered must be less than {maxLength} characters",
        REQUIRED_AT_LEAST_ONE_HOTEL_OR_CHAIN: "At least select one chain or hotel for user"
    },
    _ROLES: {
        CHAIN: "Chain Menu",
        BOOKING_CHAIN: "Booking Of Chain And Hotel",
        CHAIN_LIST: "Chain list",
        USER_MANAGEMENT: "User Management",
        DASHBOARD: "Dashboard",
        MANAGE: "Management",
        BOOKING_HOTEL: "Booking Of Single Hotel",
        ROOM_SALE: "Room Sale",
        ROOM_SALE_MANAGEMENT: "Room Sale Management",
        SALE_PACKAGE_MANAGEMENT: "Rate Plan Manangement",
        OTA_MANAGEMENT: "ezCms Vela",
        SETTING: "Setting",
        ACCOUNT_INFOMATION: "Account configuration",
        PERSONAL_ACCOUNT: "Personal Account Information",
        GENERAL_INFORMATION: "General Infomation",
        HOTEL_AMENITY: "Hotel Amenity",
        HOTEL_IMAGE: "Hotel Image",
        NEARBY_PLACE: "Nearby Place",
        ROOM_TYPE: "Room Type",
        ROOM_INFORMATION: "Room Infomation",
        ROOM_AMENITY: "Room Amenity",
        ROOM_IMAGE: "Room Image",
        HOTEL_CONFIGURATION: "Hotel Configuration",
        GENERAL_CONFIGURATION: "General Configuration",
        PAYMENT_POLICY: "Payment Policy",
        CANCELLATION_POLICY: "Cancellation Policy",
        IMAGE_LIBRARY: "Image Libary",
        HISTORY_LOG: "History Log",
        PAYMENT_METHOD: "Payment methods",
        BOOKING_ENGINE: "Booking engine",
        BOOKING_ENGINE_CONFIG: "Configuration",
        HOTEL_EMAIL: "Email",
        HOTEL_BOOKING_CONFIRM: "Confirmed booking",
        HOTEL_SERVICE: "Service",
        HOTEL_PROMOTION: "Promotion",
        HOTEL_INFORMATION: "Hotel information",
        BOOKING_MANAGEMENT: "Booking",
        SYNC_MANAGEMENT: "Channel sync",
        HEADER_FOOTER: "Template",
        SU_MANAGEMENT: "ezCms Leo",
        SU_CONNECTION: "Channel for sale",
        SU_MAPPING: "Mapping",
        HOTEL_BOOKING_REPOST: "Repost booking",
        CHAIN_SERVICE: "Service",
        CHAIN_ROOM_TYPE: "Room Type Information",
        CHAIN_RATE_PLAN: "Room sale package",
        CHAIN_TRAVEL_AGENT: "Company and agent information",
        HOTEL_TRAVEL_AGENT: "Company and agent information",
        SITEMINDER_MANAGEMENT: "ezCms SiteMinder",
        GDS_MANAGEMENT: "ezCms GDS",
        RMS_MANAGEMENT: "RMS management",
        DYNAMIC_PRICING: "Dynamic rate",
        MASTER_RATE: "Master rate",
        PACKAGE_MANAGEMENT: "Pakage deal",
        PACKAGE_ITEM: "Package item",
        PACKAGE_DEAL: "package deal",
        BE_MANAGEMENT: "ezBe",
        HOTEL_BOOKING_GROUP: "Booking group",
        BOOKING_UNMAP_HOTEL: "Unmap Booking",
        HOTEL_DASHBOARD_IGNORE_TASK: "Ignore",
        HOTEL_DASHBOARD_REUPDATE_TASK: "Reupdate",
        HOTEL_BOOKING_UNMAP_REPOST: "Repost booking",
        CHAIN_ROOM_UPDATE_QUANTITY: "Update number of rooms",
        HOTEL_DASHBOARD: "Dashboard",
        ROOM_UPDATE_QUANTITY: "Update number of rooms",
        DYNAMIC_RESTRICTION: "Dynamic restriction",
        DYNAMIC_ROOM_SALE: "Dynamic room sale",
        DYNAMIC_CONFIGURATION: "Configuration",
        CHAIN_BOOKING_REPOST: "Repost booking",
        INVENTORY: "Inventory",
        RATE: "Price",
        RESTRICTION: "Restriction",
        STOP_SELL_LIMIT: "Sell limit",
        CHANNEX_MANAGEMENT: "ezCms Vela+",
        CHANNEX_CONNECTION: "Channel for sale",
        CHANNEX_MAPPING: "Mapping",
        WARNING_METHOD: "Warning method",
        TRAVELOKA_MANAGEMENT: "ezCms Traveloka",
        STAAH_MANAGEMENT : "ezCms StaahMax",
        STAAH_MAPPING : "Mapping",
        STAAH_CONNECTION: "Channel for sale",
    },
    _LEFT_MENU: {
        COPY_RIGHT: "Copyright © 2021 ezCloud all rights reserved"
    },
    _ACTIVITY: {
        ACTION_DATE: "Action date",
        ACTION_BY: "Action by",
        APPLY_DATE: "Applied Date",
        CREATED_DATE: "Created Date",
        ROOM_NAME: "Room name",
        RATE: "Rate",
        CREATE_DATE: "Created Date",
        SEARCH_DATE: "Applied Date",
        USER_NAME: "Account",
        ROOM: "Room",
        ROOM_PLAN: "Rate plan",
        YES: "Yes",
        NO: "No",
        STOPSELL: "Stop sell",
        MINSTAY: "Min stay",
        CLOSEDTOARRIVE: "Close to arrive",
        MAXSTAY: "Max stay",
        CLOSEDTODEPATURE: "Close to departure",
        IPADDRESS: "IP Adress",
        CREATEDBY: "Created by",
        PAGING: "Page",
        DOCUMENT: "Record",
        ROOMAVAIL: "Inventory",
        ALLSELECT: "All",
        HOTELID: "Hotel ID",
        HOTELNAME: "Hotel Name",
        DATABEFORE: "Data before",
        DATAAFTER: "Data after",
        ACTION: "Action",
        HOTEL_LOGIN: "Login",
        HOTEL_CANCEL_BOOKING: "Cancelled booking",
        HOTEL_UPDATE_PAYMENT_BOOKING: "Booking confirmation",
        HOTEL_REQUEST_BOOKING: "Confirmed request booking",
        HOTEL_ROOM_PLAN_CREATE: "A new rate plan",
        HOTEL_ROOM_PLAN_UPDATE: "Rate plan information",
        HOTEL_ROOM_PLAN_COPY: "Copy plan",
        HOTEL_ROOM_PLAN_DELETE: "Deleted plan",
        HOTEL_PROMOTION_CREATE: "A new promotion",
        HOTEL_PROMOTION_UPDATE: "Promotion information",
        HOTEL_PROMOTION_COPY: "Copy promotion",
        HOTEL_PROMOTION_DELETE: "Deleted promotion",
        HOTEL_PROFILE_UPDATE: "Updated profile",
        HOTEL_AVATAR_ADD: "Add avatar",
        HOTEL_AVATAR_REMOVE: "Deleted avatar",
        HOTEL_CHANGE_PASSWORD_PROFILE: "Change password",
        HOTEL_USER_CREATE: "Created user",
        HOTEL_USER_UPDATE: "Updated user",
        HOTEL_USER_UPDATE_ROLE: "Updated role user",
        HOTEL_USER_DELETE: "Deleted user",
        HOTEL_GROUP_CREATE: "Created group user",
        HOTEL_GROUP_UPDATE: "Updated group user",
        HOTEL_GROUP_UPDATE_ROLE: "Updated group user role",
        HOTEL_GROUP_DELETE: "Deleted group user",
        HOTEL_CONTRACT_UPDATE: "Updated contract",
        HOTEL_INFO_UPDATE: "Updated info hotel",
        HOTEL_UPDATE_AMENITIES: "Updated amenities hotel",
        HOTEL_UPDATE_IMAGES: "Add new images",
        HOTEL_DELETE_IMAGES: "Deleted images",
        HOTEL_AREA_CREATED: "Created near areas",
        HOTEL_AREA_UPDATED: "Updated near areas",
        HOTEL_AREA_DELETED: "Deleted near areas",
        HOTEL_CHAIN_CREATED: "Created hotel chain",
        HOTEL_CHAIN_UPDATED: "Updated hotel chain",
        HOTEL_ROOM_CREATED: "Created room",
        HOTEL_ROOM_UPDATED: "Updated room",
        HOTEL_ROOM_COPY: "Copy room",
        HOTEL_ROOM_DELETED: "Deleted room",
        HOTEL_ROOM_AMENITY: "Updated amenities room",
        HOTEL_ROOM_ADD_IMAGES: "Add room images",
        HOTEL_ROOM_DELETE_IMAGES: "Deleted room images",
        HOTEL_UPDATE_HOTEL_SETTING_INFO: "Updated hotel setting",
        HOTEL_PAYMENT_POLICY_CREATED: "Created payment policy",
        HOTEL_PAYMENT_POLICY_UPDATED: "Updated payment policy",
        HOTEL_PAYMENT_POLICY_DELETED: "Deleted payment policy",
        HOTEL_CANCEL_POLICY_CREATED: "Created cancel policy",
        HOTEL_CANCEL_POLICY_UPDATED: "Updated cancel policy",
        HOTEL_CANCEL_POLICY_DELETED: "Deleted cancel policy",
        HOTEL_SETTING_PAYMENT_GATE: "Setting payment gate",
        HOTEL_ADD_IMAGES_SLIDE: "Add images slide",
        HOTEL_DELETE_IMAGES_SLIDE: "Delete images slide",
        HOTEL_REMOVE_CONNECT_AGENT: "Caceled connect agent",
        HOTEL_UPDATE_LEVEL_AGENT: "Update level agent connect",
        HOTEL_RETURN_CONNECT_AGENT: "Return connect agent",
        PMS_CONFIRM: "PMS confirm",
        RATE_CATEGORY_CREATE: "Create new price category",
        RATE_CATEGORY_UPDATE: "Price Category Details",
        ROOM_CATEGORY_CREATE: "Create new room category",
        ROOM_CATEGORY_UPDATE: "Room Category Details"
    },
    STATUS_CREATE_NEW: "Create new",
    STATUS_DELIVERED: "Deliverd",
    STATUS_SALE_SEND_HOTEL: "Sent Hotel",
    STATUS_SALE_ADMIN_SEND_BACK: "SM sent back",
    STATUS_SALE_ADMIN_PASSED: "SM passed",
    STATUS_QC_SENT_BACK_HOTEL: "QC sent back",
    STATUS_QC_PASSED_HOTEL: "QC passed",
    STATUS_SALE_ADDITIONAL: "Sent Infor",
    STATUS_QC_SENT_BACK_INFOR: "Sent back Infor",
    STATUS_QC_PASSED_INFOR: "Passed Infor",
    STATUS_ONSITE: "Onsite",
    STATUS_OFFSITE: "Offsite",
    STATUS_SIGNED: "Signed",
    STATUS_WAITING_SIGN: "Waiting sign",
    STATUS_CLOSED: "Closed",
    STATUS_IN_DISPUTE: "In dispute",
    STATUS_LIQUIDATED: "Liquidated",
    STATUS_COMPLETED: "Completed",
    STATUS_CM_PASSED: "CM passed",
    STATUS_CM_SEND_BACK: "CM send back",
    STATUS_RELEASED: "Released",
    STATUS_RENEWAL: "Renewal",
    STATUS_CHANGED: "status changed to",
    STATUS_NEW_CREATE: "Create new",
    STATUS_AWAIT_PAYMENT: "Await paymeny",
    STATUS_AWAIT_FULLY_PAYMENT: "Await fully payment",
    STATUS_PAYMENT_FAILED: "Payment failed",
    STATUS_CONFIRM: "Confirm",
    ALL: "All",
    CANCEL: "Cancelled by customer",
    AWAIT_PAYMENT: "Waiting for pay",
    IN_SERVICE: "In service",
    PAYMENT_FAILED: "Payment failed",
    CONFIRM: "Confirmed",
    AWAIT_FULLY_PAYMENT: "Partial payment",
    VOID: "Cancelled by hotel",
    STATUS_WAIT_FEEDBACK: "Waiting for feedback",
    STATUS_FEEDBACK: "Feedback",
    STATUS_COMPLETE: "Completed",
    STATUS_CANCEL: "Cancelled",
    BOOKING: "Booking",
    BOOKING_STATUS: "Status of Booking",
    BOOKING_REQUEST_STATUS: "Status of Send Request",
    CONTRACT_STATUS: "Contract status",
    TA_STATUS: "Travel Agent status",
    HOTEL_STATUS: "Hotel status",
    SHOW_MORE: "View more",
    NOTIFICATION: "Notification",
    HAS_JUST_JOINED_ONEI: "has joined in One Inventory",
    HAS_JUST_CREATED_ONEI: "has created in OneInventory.com",
    ANNEX_OF_CONTRACT: "Phụ lục hợp đồng số",
    YOUR_AGENT: "Your agent",
    NOTIFICATIONS: "Notifications",
    MARK_AS_READ: "Mark as read",
    CONTACT_NUMBER: "Contract number",
    HOTELS_CONTRACT: "Contract of Hotel",
    AGENTS_CONTRACT: "Contract of Agent",
    ADDENDUM_OF_CONTRACT: "Addendum contract number",
    EXTEND_CONTRACT: "Extend contract",
    BELONG_HOTEL: "of Hotel",
    BELONG_AGENT: "of Agent",
    AGENT: "Agent",
    NEW_TA: "New agent",
    RE_RELEASE: "Re release",
    AGO: "ago",
    MONTHS: "months",
    YEARS: "years",
    SECONDS: "seconds",
    MINUTES: "minute",
    HOURS: "hour",
    NOW: "right now",
    DAYS: "days",
    REQUEST_EMPTY: "Request empty",
    STATUS_INCORRECT: "Status incorrect",
    STATUS_CONTRACT_INCORRECT: "Status contract incorrect",
    NO_NOTIFICATION: "There are no new notifications",
    ADDENDUM_STATUS: "Addendum status",
    OVER_CHARACTER: "You've exceeded the number of characters",
    HOTEL_LOG_bookingCode: "Booking Id",
    HOTEL_LOG_agentName: "Agent name",
    HOTEL_LOG_customer: "Customer name",
    HOTEL_LOG_createdDate: "Created date",
    HOTEL_LOG_checkinDate: "Check-in date",
    HOTEL_LOG_checkoutDate: "Check-out date",
    HOTEL_LOG_totalCost: "Total cost",
    HOTEL_LOG_payableAmount: "Payable amount",
    HOTEL_LOG_bookingStatus: "Status booking",
    HOTEL_LOG_active: "Active",
    HOTEL_LOG_amount: "Amount/Percent",
    HOTEL_LOG_cancellationDay: "Cancellation day",
    HOTEL_LOG_cancellationType: "Cancellation type",
    HOTEL_LOG_startDate: "Start date",
    HOTEL_LOG_endDate: "End date",
    HOTEL_LOG_hotelId: "Hotel Id",
    HOTEL_LOG_type: "Apply time",
    HOTEL_LOG_notifyToEmail: "Email",
    HOTEL_LOG_notifyCCEmail: "CC Email",
    HOTEL_LOG_notifyBCCEmail: "BCC Email",
    HOTEL_LOG_includeTaxesInPrice: "Include taxes in price",
    HOTEL_LOG_language: "Language",
    HOTEL_LOG_weekend: "Weekend",
    HOTEL_LOG_email: "Email",
    HOTEL_LOG_checkinAfterHour: "Check-in after",
    HOTEL_LOG_checkoutBeforeHour: "Check-out before",
    HOTEL_LOG_roomServices: "Room service",
    HOTEL_LOG_hotelPolicyVi: "Hotel policy VI",
    HOTEL_LOG_hotelPolicyEn: "Hotel policy EN",
    HOTEL_LOG_yearOfBuild: "Year of build",
    HOTEL_LOG_numberOfFloors: "Number of floor",
    HOTEL_LOG_numberOfRooms: "Number of room",
    HOTEL_LOG_minutesToAirport: "Minutes to Airport",
    HOTEL_LOG_babyAgeDetermine: "Baby age determine",
    HOTEL_LOG_childAgeDetermine: "Child age determine",
    HOTEL_LOG_electronicVoltage: "Electronic voltage",
    HOTEL_LOG_distanceToAirport: "Distance to airport",
    HOTEL_LOG_serviceTaxPercent: "Service tax percent",
    HOTEL_LOG_valueAddedTaxPercent: "TAX percent",
    HOTEL_LOG_distanceToCenter: "Distance to center",
    HOTEL_LOG_lat: "Latitude",
    HOTEL_LOG_lng: "Longtitude",
    HOTEL_LOG_phoneNum: "Phone number",
    HOTEL_LOG_hotLine: "Hote line",
    HOTEL_LOG_starRanking: "Star ranking",
    HOTEL_LOG_website: "Website",
    HOTEL_LOG_addressVi: "Address VI",
    HOTEL_LOG_addressEn: "Address EN",
    HOTEL_LOG_hotelNameVi: "Hotel name VI",
    HOTEL_LOG_hotelNameEn: "Hotel name EN",
    HOTEL_LOG_hotelTypeVi: "Hotel type VI",
    HOTEL_LOG_hotelTypeEn: "Hotel type EN",
    HOTEL_LOG_cityVi: "City VI",
    HOTEL_LOG_countryVi: "Country VI",
    HOTEL_LOG_locationVi: "Province VI",
    HOTEL_LOG_cityEn: "City EN",
    HOTEL_LOG_areaVi: "Area VI",
    HOTEL_LOG_countryEn: "Country EN",
    HOTEL_LOG_locationEn: "Province EN",
    HOTEL_LOG_areaEn: "Area EN",
    HOTEL_LOG_descriptionVi: "Description VI",
    HOTEL_LOG_descriptionEn: "Description EN",
    HOTEL_LOG_depositType: "Deposit type",
    HOTEL_LOG_cutOfDate: "Deposit before number of day",
    HOTEL_LOG_paymentDay: "Payment before number of day",
    HOTEL_LOG_proNameVi: "Promotion name VI",
    HOTEL_LOG_proNameEn: "Promotion name EN",
    HOTEL_LOG_promoType: "Type",
    HOTEL_LOG_sessionType: "Type",
    HOTEL_LOG_discountOrSurcharge: "Discount / surcharge rates",
    HOTEL_LOG_coupon: "Coupon",
    HOTEL_LOG_orderType: "Apply type",
    HOTEL_LOG_notApplyDates: "Not apply date",
    HOTEL_LOG_applyPlans: "Apply plan",
    HOTEL_LOG_applyAgents: "Apply agent",
    HOTEL_LOG_applyLevels: "Apply agnet",
    HOTEL_LOG_applyDays: "Apply days",
    HOTEL_LOG_bookType: "Book type",
    HOTEL_LOG_fromDays: "From",
    HOTEL_LOG_toDays: "To",
    HOTEL_LOG_minOrder: "Min order",
    HOTEL_LOG_freeForMinOrder: "Free for min order",
    HOTEL_LOG_percentOrFixed: "Percent or fixed",
    HOTEL_LOG_startBook: "From book date",
    HOTEL_LOG_endBook: "To book date",
    HOTEL_LOG_objectType: "Object type",
    HOTEL_LOG_delete: "Delete",
    HOTEL_LOG_promotionNameVi: "Promotion name VI",
    HOTEL_LOG_promotionNameEn: "Promotion name EN",
    HOTEL_LOG_promotionDesVi: "Description VI",
    HOTEL_LOG_promotionDesEn: "Description EN",
    HOTEL_LOG_code: "Send request Id",
    HOTEL_LOG_note: "Note",
    HOTEL_LOG_requestStatus: "Send request status",
    HOTEL_LOG_fullName: "Full name",
    HOTEL_LOG_gender: "Gender",
    HOTEL_LOG_phoneNumber: "Phone number",
    HOTEL_LOG_position: "Position",
    HOTEL_LOG_address: "Addess",
    HOTEL_LOG_maxChildren: "Max children",
    HOTEL_LOG_maxAdults: "Max adults",
    HOTEL_LOG_totalRoom: "Total room",
    HOTEL_LOG_defaultPrice: "Default price",
    HOTEL_LOG_weekendPrice: "Weekend price",
    HOTEL_LOG_roomSize: "Room size",
    HOTEL_LOG_numberOfExtraBeds: "Number of extra beds",
    HOTEL_LOG_bedTypeTitleVi: "Room name VI",
    HOTEL_LOG_bedTypeTitleEn: "Room name EN",
    HOTEL_LOG_viewVi: "Room view VI",
    HOTEL_LOG_viewEn: "Room view EN",
    HOTEL_LOG_bedTypeVi: "Bed type VI",
    HOTEL_LOG_bedTypeEn: "Bed type EN",
    HOTEL_LOG_sellAllotment: "Allotment",
    HOTEL_LOG_roomName: "Room type",
    HOTEL_LOG_amenityName: "Room amenity",
    HOTEL_LOG_id: "Code",
    HOTEL_LOG_nameVi: "Name Vi",
    HOTEL_LOG_nameEn: "Name En",
    HOTEL_LOG_adultsIncluded: "Adults included",
    HOTEL_LOG_exAdult: "Extra adults price",
    HOTEL_LOG_aexType: "Adults type",
    HOTEL_LOG_childrenInclued: "Children included",
    HOTEL_LOG_exChild: "Extra children price",
    HOTEL_LOG_cexType: "Children type",
    HOTEL_LOG_start: "Start date",
    HOTEL_LOG_end: "To date",
    HOTEL_LOG_sesType: "Time to stay",
    HOTEL_LOG_minStay: "Minimum number of nights",
    HOTEL_LOG_maxStay: "Maximum number of nights",
    HOTEL_LOG_extraBedPrice: "Extra bed price",
    HOTEL_LOG_rooms: "Room type",
    HOTEL_LOG_meals: "Meals included",
    HOTEL_LOG_plans: "Plan name",
    HOTEL_LOG_promotions: "Promotion name",
    HOTEL_LOG_avatar: "Avatar",
    HOTEL_LOG_userName: "User name",
    HOTEL_LOG_userGroup: "User group",
    HOTEL_LOG_owner: "Position",
    HOTEL_LOG_name: "Name",
    HOTEL_LOG_functions: "Function code",
    HOTEL_LOG_users: "Account",
    HOTEL_LOG_description: "Description",
    HOTEL_LOG_enterpriseName: "Enterprise name",
    HOTEL_LOG_registeredAddress: "Enterprise address",
    HOTEL_LOG_taxCode: "Tax code",
    HOTEL_LOG_bankAccountNumber: "Bank account number",
    HOTEL_LOG_bankAccountName: "Bank account name",
    HOTEL_LOG_bankName: "Bank name",
    HOTEL_LOG_bankBranch: "Bank branch",
    HOTEL_LOG_representative: "Representative",
    HOTEL_LOG_signer: "Signer",
    HOTEL_LOG_area: "Area",
    HOTEL_LOG_location: "Location",
    HOTEL_LOG_city: "City",
    HOTEL_LOG_country: "Country",
    HOTEL_LOG_hotline: "Hoteline",
    HOTEL_LOG_images: "Name images",
    HOTEL_LOG_amenities: "Name amenities",
    HOTEL_LOG_landmark: "Landmark",
    HOTEL_LOG_distance: "Distance",
    HOTEL_LOG_unit: "Unit",
    HOTEL_LOG_hotelChains: "Hotel chains",
    HOTEL_LOG_roomId: "Room id",
    HOTEL_LOG_views: "Views",
    HOTEL_LOG_agentId: "Agent id",
    HOTEL_LOG_areas: "Areas name",
    HOTEL_LOG_level: "Agent level",
    HOTEL_LOG_userGroups: "Goup name user",
    HOTEL_LOG_hotelType: "Hotel Type",
    HOTEL_LOG_logo: "Logo Hotel",
    HOTEL_LOG_currency: "Currency",
    HOTEL_LOG_pmsConfirm: "PMS",
    HOTEL_LOG_restriction: "Restriction",
    OTHER_POLICY: "Other policy",
    IF_CANCELED: "If you cancel your reservation within",
    DAYS_PRIOR_TO_ARRIVAL_DATE: "days in advance of your arrival date",
    OF_THE_BOOKING_VALUE_WILL_CHARGED: "of the booking value will be charged",
    WILL_BE_CHARGED: "you will be charged",
    WILL_BE_CHARGED_POCUP: "You will be charged",
    RESERVATIONS: "Reservations",
    REQUIES_A_DEPOSIT: "require a deposit",
    OF_THE_BOOKING_VALUE: "of the booking value",
    THE_REMAINING_AMOUNT: "the remaining amount must be paid before the",
    THE_REMAINING_DAYS: "the remaining amount must be paid before the checkin",
    PAYMENT_WHEN_CHECKIN: "Payment before check-in",
    PAYMENT_WHEN_CHECKOUT: "Payment before check-out",
    VIEWDETAIL_PHOTO: "View more photos",
    PAYMENT_100: "Pay 100% of the booking value",
    CANCEL_100: "Cancellation will be charged 100% of the booking value",
    FREE_DEPOSIT: "free deposit",
    ARRIVAL_DATE: "arrival date",
    LEAVING_DATE: "leaving date",
    CHIlDRENTS: "children",
    CHIlDRENT: "Child",
    ADULTS: "adult",
    FREE_CANCEL: "free cancelation",
    CHARGE: "additional fee is charged",
    CHARGE_AS_ADULTS: "charge as adults",
    CHILDREN_BELOW: "Children under",
    CHILDREN_OVER: "Children over",
    CHILDREN_FROM: "Children from",
    AGES: "yeal old",
    DISCOUNT: "Discount",
    READ_MORE: "Read more",
    READ_LESS: "Read less",
    PICTURE_FACILITIES: "Photos & Facilities",
    CAPACITY: "Capacity",
    OPTIONS: "Room Plan",
    ALL_CAPACITY: "View all facilities",
    UN_ALL_CAPACITY: "Show less",
    PAYMENT_BEFORE: "Payment before",
    NO_PAYMENT_BEFORE: "No prepayment required",
    BOOK_WITHIN: "Book within",
    PAYMENT_100_NOW: "pay 100% of the booking value",
    CANCEL_FREE_FROM: "Free cancellation of booking from",
    TO_H: "come first",
    CANCEL_FREE_BEFORE: "There is no cancellation fee before",
    FROM: "From",
    UNTIL: "Until",
    EARLY_CONFIRM: "Early confirmation!",
    SEND_REQUEST_BOOKING: "SUBMIT A BOOKING REQUEST",
    SEND_REQUEST_CART: "Add request",
    SEND_REQUEST_NOW: "SEND REQUEST NOW",
    AREA_INFO: "Area info",
    CANCELLATION_POLICY: "Cancellation Policy",
    CHILD_AND_BED: "Children Policies",
    IF_CANCELED_BEFORE: "Cancellation before",
    THERE_ARE: "There are",
    ROOM_TYPES_WITH: "room types with",
    OPTIONS_DETAIL: "room plan",
    SPECIAL_OFFER: "Special Offer",
    HOTEL_POLICY: "Hotel policy",
    CHECK_AVAILABILITY: "Search room",
    PRICE_FOR: "Price for",
    ONLY: "Only",
    NIGHT: "night(s)",
    ROOM_LEFT: "room left",
    THE_PRICE_DOES_NOT_INCLUDE_VAT: "Price does not include Taxes",
    SERVICE_CHARGE: "Service charge",
    THE_PRICE_DOES_INCLUDE_VAT: "Price does include Taxes",
    THE_PRICE_DOES_NOT_INCLUDE_VAT_NOT_TOOL: "Not includes taxes",
    SERVICE_CHARGE_NOT_TOOL: "charges",
    THE_PRICE_DOES_INCLUDE_VAT_NOT_TOOL: "Includes taxes",
    ADD_ROOM: "Add room",
    BOOK_NOW: "BOOK NOW",
    AND_SERVICE_CHARGE: "and Service charges",
    AND_SERVICE_CHARGE_NOT_TOOL: "and charges",
    NO_CHARGE: "No charge",
    ADULTS_BTN_RESULTSEARCH: "Adults",
    ABOVE_12_YEARS: "Above 12-year",
    CHILDRENS_BTN_RESULTSEARCH: "Children",
    BELLOW_12_YEARS: "Below 12-year",
    ROOM: "Room",
    HOW_OLD_ARE_THE_CHILDRENT: "How old are the children you're traveling with",
    CHECKIN: "Check in",
    CHECKOUT: "Check out",
    T2: "MON",
    T3: "TUE",
    T4: "WED",
    T5: "THU",
    T6: "FRI",
    T7: "SAT",
    T8: "SUN",
    TH1: "January",
    TH10: "October",
    TH11: "November",
    TH12: "December",
    TH2: "February",
    TH3: "March",
    TH4: "April",
    TH5: "May",
    TH6: "June",
    TH7: "July",
    TH8: "August",
    TH9: "September",
    MOST_POPULAR: "Popular facilities",
    EVERY_OPTION: "Other facilities",
    GIFT_CODE: "Discount code",
    COPY_THIS_CODE: "Copy this code and paste it into the payment page",
    ENDOW: "Discount",
    APPLY_FOR_MIN_ORDER_FROM: "for minimum orders from",
    APPLY_ON_TOTAL_ROOM_RATE: "apply on total room charge",
    APPLY_ON_TOTAL_BOOKING: "applied on total booking value",
    APPLY_ON_TOTAL_SERVICE: "applicable on all service charges",
    APPLY_ALL_ORDER: "for every order",
    NO_ROOM_LEFT: "Room unavailable",
    QUIT_FAVORITE: "Added to favorites",
    SUM_PROMOTION: "Cumulative promotion",
    PRIORITY_PROMOTION: "Priority promotion ",
    BEST_PROMOTION: "Best promotion",
    TYPE_PROMOTION: "Promotion setting",
    INDEX: "Index",
    PMS_SUCCESS: 'Congratulations, the hotel has finished selling a room on ezCrs',
    COMPLETE_INFOMATION: "Complete infomation",
    SERVICE: {
        CONFIRM_DELETE_SERVICE: "Are you sure delete?",
        CONFIRM_DEACTIVE_SERVICE: "Are you sure deactive?",
        SPECIAL_PRICE: "Daily rate",
        SPECIAL_PRICE_TITLE: "Date",
        SPECIAL_PRICE_VALUE: "Price",
        ADD_SPECIAL_PRICE: "Add special days price",
        HAS_EXITS: "has exits",
        LINK: "Link list",
        STATUS_SYNC: "Sync status",
        ORDER: "Order",
        THUMBNAIL: "Image",
        STATUS: "Status",
        DEACTIVE: "Inactive",
        ACTIVE: "Active",
        SYNC_PMS: "Sycn from PMS",
        LIST: "Service list",
        INFO: "Service information",
        NAME: "Title",
        DESCRIPTION_INFO: "Description",
        DESCRIPTION_INFO_DEFAULT: "Description",
        CODE: "Service code",
        TIME_APPLY: "Time setting",
        DAY_APPLY: "Days of week",
        DAYS_NOT_APPLY: "Blackout dates",
        ADD_DAYS_NOT_APPLY: "Add blackout dates",
        TIME_BOOK: "Booking date",
        TIME_USE: "Staying date",
        FREE: "Free service",
        PREMIUM: "Paid service",
        PRICE: "Rate",
        PRICE_STATUS: "Service fee",
        INCLUDE_TAX: "Included tax",
        CURRENCY: "Currency",
        COPPY: "Copy",
        UNIT: "Unit",
        PER_BOOKING: "Per booking",
        PER_PERSON_PER_NIGHT: "Per person per day",
        PER_ROOM: "Per room",
        PER_ROOM_PER_NIGHT: "Per room per day",
        PER_PERSON: "Per person",
        TAX_LABEL: "Tax",
        MAXBOOK: "Max order",
        PACKAGE_SELL: "Rate plans",
        PACKAGE_ALL: "All",
        PACKAGE_SPEC: "Some rate plans",
        SELL_CHANEL: "Sales channel applied",
        CHANEL_ALL: "Apply on all sale channels",
        CHANEL_SPEC: "Apply on semi-specific channels",
        CODE_MAX_LENGTH: "must be greater than 2 characters",
        SPECIAL_DESC: "Price for a specific date",
        NOT_EMPTY: "may not be blank",
        ERROR_DUPLICATE_DAY: "The dates around overlap, please check again",
        TAX_DEFAULT: "Default",
        UPDATE_IMAGE_SUCCESS: "Upload image success",
        UPDATE_IMAGE_FAIL: "Upload image fail",
        CANCEL: "Cancel",
        NOTHUMB: "Photo may not be blank",
        IMAGE_TOO_LARGE: "Photos up to 8MB in size",
        BINDING_PRICE: "Included in the room rate",
        MAXQUATITY: "Maximum number of services",
        UNLIMIT: "Unlimited",
        LIMIT: "Limit",
        ONE_TIME: "One time",
        CONFIRM_ACTIVE_SERVICE: "Are you sure?",
        BENEFIT: "Benefits & Utilities",
        MANDATORY_ADD_ON: "Mandatory add on",
        MANDATORY_ADD_ON_INFO: "If selected, the service will be applied automatically when the reservation made.",
    },
    IMAGE_NOT_EXIST: "No photos yet",
    IMAGE_SERVICE: "Photo",
    _ROOM_SALE: {
        ROOM_TYPE: {
            ROOM_TYPE: "Room type",
            ROOM_CODE: "Room code",
            MAX_PERSON: "Max guest",
            MAX_ADULT: "Max adult",
            MAX_CHILD: "Max child",
            MAX_KID: "Max baby",
            ROOM_PARENT_TYPE: "Parent room",
            ERROR_ROOM_CODE: "Room code cannot be duplicated or left blank",
            ERROR_ROOM_PARENT: "The room you choose has been configured as the parent of the current room"
        },
        EXPAND: "Show more",
        UNEXPAND: "Show less",
        SELL_CHANNEL: "Channel",
        SELL_MARKET: "Market",
        SELL_CHANNEL_ALL: "All channels",
        SELL_CHANNEL_SPEC: "Some channels",
        SELL_MARKET_ALL: "All markets",
        SELL_MARKET_SPEC: "Some markets",
        LABEL_SEARCH_CODE_NAME: "Code/Room type",
        ENTER_HOTEL_NAME_OR_CODE: "Enter code/room type",
    },
    _SALE_PACKAGE: {
        SALE_PACKAGE: "Rate plan",
        ADD_NEW: "Add new rate plan",
        ENTER_SALE_PACKAGE_NAME_OR_CODE: "Enter code/rate plan",
        RATE_CATEGORY: "Rate category",
        RATE_CATEGORY_ADD_NEW: "Add new rate category",
        ROOM_CATEGORY: "Room category",
        ROOM_CATEGORY_ADD_NEW: "Add new room category"
    },
    ADD_NEW_ROOM: "Add new room",
    ROOMS_PER_PAGE: "Rooms per page",
    NOT_EMPTY: "Please enter value",
    _SERVICE_PACKAGE: {
        AGE_MAX_CHILD: "Max child age",
        AGE_MAX_BABY: "Max baby age",
        DAY_APPLY_IN_WEEK: "Days of week",
        PAYMENT_POLICY: "Payment policies",
        CANCEL_POLICY: "Cancel policy",
        APPLY_OBJECT: "Parties",
        APPLY_CARD: "Card type",
        PACKAGE_CODE: "Rate code",
        ADD_PAYMENT_POLICY: "Add payment policy",
        ADD_CANCEL_POLICY: "Add cancel policy",
        SALE_PACKAGE_CODE: "Rate code",
        ERROR_SALE_PACKAGE_CODE: "Rate code cannot be duplicated or left blank",
    },
    PACKAGE_PER_PAGE: "Packages per page",
    ADD_RANGE_DAYS_NOT_APPLY: "Add blackout date",
    NOT_APPLY_RANGE_DATE: "Blackout date",
    ROOM_AVAILABLE: "Inventory",
    NO_ROOM_PARENT: "None",
    ROOM_RATE: "Room rate",
    ADD_SALE_PACKAGE: "Add rate plan",
    ADD_DATE_RANGE: "Add date range",
    CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE: "Confirm delete date range?",
    SELECT_SALE_PACKAGE: "Select rate plan",
    LIST_SALE_PACKAGE_EMPTY: "List rate plan empty",
    VIEW_TABLE: "View as table",
    VIEW_CALENDAR: "View as calendar",
    SELECT_ROOM_TO_VIEW: "Please select room to view",
    SHOW_ROOM_AVAIL: "Show available quantity",
    ROOM_CONNECTED_OTA: "Room has sync OTA",
    RESTRICTION_PACKAGE: "Restriction Package",
    RESTRICTION: "Restriction",
    ENTER_RESTRICTION_NAME_OR_CODE: "Enter restriction name or code",
    CONFIRM_DELETE_RESTRICTION: "Confirm delete restriction package",
    RESTRICTION_INFOMATION: "Restriction information",
    CONFIG_RESTRICTION: "Restriction config",
    DEFAULT: "Default",
    ROOMTYPE: "Room type",
    ROOMPLAN: "Rate plan",
    RESTRICTION_NAME: "Restriction name",
    ADD_NEW_RESTRICTION: "Add new restriction",
    METADATA: "Select update",
    RESTRICTION_BULK_UPDATE: "Bulk update",
    RESTRICTION_BULK_DELETE: "Bulk delete",
    ROOM_AVAIL: "Inventory",
    SELL_LIMIT: "Sell limit",
    STOP_SELL_LIMIT: "Stop sell limit",
    PRICE: "Rate",
    MANAGE_SYNC_OTA: "Channel sync",
    MANAGE_ALIAS_OTA: "ezCms Vela",
    ALL_ROOM: "All room",
    NOT_SELECT_SALE_PACKGE: "Please select rate plan",
    DATA_INPUT_INVALID: "Data invalid",
    UPDATE: "Update",
    SELECT_ROOM_APPLY: "Room type",
    SELECT_SALE_PACKAGE_APPLY: "Choose rate plan",
    SPECIAL_PRICE: "Daily rate",
    ENTER_PRICE_AND_CHOSE_SALE_PACAKGE: "Price, rate plan is empty",
    minStay: "Minimum stay",
    maxStay: "Maximum stay",
    minStayArrival: "Minimum stay arrival",
    maxStayArrival: "Maximum stay arrival",
    minBookingWindow: "Minimum booking window",
    maxBookingWindow: "Maximum booking window",
    minBookingWindowByHour: "Minimum booking window by hour",
    maxBookingWindowByHour: "Maximum booking window by hour",
    exactStay: "Exact stay",
    exactStayArrival: "Exact stay arrival",
    fromCheckout: "From checkout",
    cutOfTime: "Cut Of Time",
    closedOnArrival: "Close to arrival",
    closedOnDeparture: "Close to departure",
    closed: "Stop sell",
    belongTo: "Belong to",
    appliedFor: "Applied for",
    CHANNEL_APPLY: "Channel",
    CHANNEL_EMPTY: "Empty channel",
    APPLY_FOR: "Apply for",
    priceExtraAdult: "Extra adult rate",
    priceExtraChild: "Extra child rate",
    priceExtraBaby: "Extra baby rate",
    DAY_SPECIAL: "Daily rate",
    SUN_SHORT: "Sun",
    MON_SHORT: "Mon",
    TUE_SHORT: "Tue",
    WED_SHORT: "Wed",
    THU_SHORT: "Thu",
    FRI_SHORT: "Fri",
    SAT_SHORT: "Sat",
    JAN_SHORT: "Jan",
    FEB_SHORT: "Feb",
    MAR_SHORT: "Mar",
    APR_SHORT: "Apr",
    MAY_SHORT: "May",
    JUN_SHORT: "Jun",
    JUL_SHORT: "Jul",
    AUG_SHORT: "Aug",
    SEP_SHORT: "Sep",
    OCT_SHORT: "Oct",
    NOV_SHORT: "Nov",
    DEC_SHORT: "Dec",
    NO_SELECT: "No change",
    OPEN: "Open",
    CONFIRM_DELETE_SPECIAL_PRICE: "Confirm delete daily rate",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_ADULT: "Confirm delete daily extra adult rate",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_CHILD: "Confirm delete daily extra child rate",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_BABY: "Confirm delete daily extra baby rate",
    REMOVE_SPECIAL_PRICE: "Delete daily rate",
    NO_DATA: "No data available",
    CURRENCY_OTA: "Currency on channel",
    ROOM_TYPE_ON_OTA: "Room type on OTA",
    SALE_PACKAGE_ON_OTA: "Rate plan on OTA",
    NUMBER_OF_PERSON: "Number of person",
    PACKAGE_TYPE: "Package type",
    RATES: "Rates",
    RATES_OSCILLATE: "Extra",
    REGULAR_PRICE: "Regular rate",
    SYNCED: "Synced",
    ROOM_CLOSED: "Closed",
    NO_SALEPACKAGE_AVAIL: "Rate plan is unavailable",
    YES: "Yes",
    NO: "No",
    BOOKING_CUSTOMER_NAME: "Customer name",
    BOOKING_EMPTY: "No booking found.",
    BOOKING_CHANNEL: "Channel",
    BOOKING_HOTEL: "Hotel",
    STT: "No.",
    BOOKING_IS_NOT_EXIST: "Booking is not exist",
    ADD_NEW_SALE_CHANNEL: "Add new channel",
    CONNECT: "Connect",
    SELECT_SALE_CHANNEL: "Select channel",
    PHONE_INVALID: "Phone invalid",
    EMAIL_INVALID: "Email invalid",
    LOGIN_NOW: "Login now !",
    POLICY_NAME: "Policy name",
    POLICY_DESCRIPTION: "Policy description",
    DESCRIPTION: "Description",
    APPLY_DAY: "Apply",
    DEPOSIT_UNIT: "Unit",
    APPLY_FOR_STAYING: "By staying date",
    APPLY_FOR_BOOKING: "By booked date",
    CHECKOUT_DATE: "Check-out date",
    CHECKIN_DATE: "Check-in date",
    BEFORE_CHECKIN_DATE: "Before check-in date",
    BEFORE_CHECKOUT_DATE: "Before check-out date",
    CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE: "Cancel booking widthin x day",
    NIGHT_CAP: "0 night | 1 night | {count} nights",
    CHANGE_PASSWORD_REQUEST_NO_LONGER_WORK: "Your change password request is no longer work!",
    MAXROOM_1000: "Max room size is 1000",
    DATA_INPUT_MAX_100_PERCENT: "Maximum value 100",
    DATA_INPUT_MAX_10_NIGHT: "Maximun value 10",
    DUPLICATE_CODE: "Duplication Code",
    CREATE: "Create",
    BULK_UPDATE: "Bulk update",
    SETUP_OTA: "Setup OTA",
    AUTH: "Access Hotel",
    RECEIVE_BOOKING_FROM_OTA: "Receive booking from OTA",
    UPDATE_INVENTORY: "Update inventory from PMS",
    RECEIVE_INVENTORY_UPDATE_FROM_PMS: "Reveive inventory update to OTA",
    PUSH_BOOKING_NOTIFICATION_TO_PMS: "Push booking notification to PMS",
    HOTEL_INFO: "Hotel info",
    HOTEL_IMAGE: "Hotel image",
    HOTEL_AREA: "Hotel area",
    HOTEL_AMENITY: "Hotel amenity",
    HOTEL_CANCELLATION_POLICY: "Hotel cancellation policy",
    HOTEL_SETTING: "Hotel setting",
    HOTEL_PAYMENT_POLICY: "Hotel payment policy",
    SETUP_AND_MAPPING_TO_OTA: "Setup and mapping to OTA",
    HOTEL_RATE_PLAN: "Hotel rate plan",
    HOTEL_RESTRICTION: "Hotel restriction",
    HOTEL_ROOM_TYPE: "Hotel room type",
    HOTEL_ROOM_TYPE_AMENITY: "Hotel room type amenty",
    HOTEL_ROOM_TYPE_AVAILABILITY: "Hotel room type availability",
    HOTEL_ROOM_RATE: "Room rate",
    HOTEL_ROOM_TYPE_STOP_SELL: "Hotel room type stop sell",
    HOTEL_ROOM_RATE_ADULT: "Hotel room rate adult",
    HOTEL_ROOM_RATE_CHILD: "Hotel room rate child",
    HOTEL_ROOM_RATE_BABY: "Hotel room rate baby",
    HOTEL_ROOM_RATE_SPECIAL: "Hotel room rate special",
    STAFF_INFO: "Staff info",
    STAFF_PASSWORD: "Staff password",
    STAFF_AVATAR: "Staff avatar",
    STAFF_LOGIN: "Staff login",
    HOTEL_REGISTER: "Hotel register",
    CHANGE_STATUS: "Change status",
    LOG_ACTION: "Action",
    LOG_FUNCTION: "Function",
    LOG_CONTENT: "Log",
    LOG_DATE_CREATE: "Created date",
    LOG_USERNAME: "Username",
    PRICE_ON_OTA: "Rate on OTA",
    PRICE_ON_DEFINED: "Declared rate",
    STOP_SELL_TRIGGER: "Stop sell trigger",
    DOWNLOAD: "Download",
    CONFIRM_CHANGE_STATUS_SALE_PACKAGE: "Rate plan has synced with OTA, are you sure to change status ?",
    CONFIRM_CHANGE_STATUS_ROOMTYPE: "Room type has synced with OTA, are you sure to change status ?",
    hotel_id: "Hotel ID",
    property_id: "Property ID",
    HOTEL_ROOM_TYPE_IMAGES: "Room image",
    IMAGE_MANAGAMENT: "Gallery",
    UNIT: "Unit",
    NEARBY_TYPE: "Nearby type",
    DIALOG_CONFIRM_DESC: "Limited update according to the configuration of the rate plan ?",
    CANNOT_GET_INFO_FROM_OTA_1: "Comunication with OTA are down.",
    CANNOT_GET_INFO_FROM_OTA_2: "Please contact us by 1900 9013 or email to hotro@ezcloud.vn",
    ROOMTYPE_HAS_NO_RATEPLAN: "Please fill a pre-configured combination of room type, rate plan, and channel.",
    MAX_LENGTH_10: "Data has limit 10 character",
    UPDATE_BY: "Update by",
    OTA_HAS_NO_RATEPLAN: "There are no packages for this OTA yet",
    PRICE_IS_REQUIRED: "Price is empty",
    HOTEL_ROOM_IS_OVER_LIMIT: "Hotel room is over limit",
    CONFIRM_DELETE_PROMOTION: "Are you sure to delete promotion ?",
    ADD_NEW_PROMOTION: "Add new promotion",
    ADD_NEW_SERVICE: "Add new service",
    PRICE_EXTRA: "Extra rate",
    PERSON_NUMBER: "Person",
    DETAIL: "Detail",
    PRICE_AND_PERSON_IS_REQUIRED: "Price and number of person are required",
    CHOOSE_LANG_PAYMENT: "Select payment method language",
    ENTER_CONTENT_SHOW: "Enter what to display",
    CONFIG_BE: "Booking Engine",
    SAVE_SUCCESS: "Successfully saved",
    CONFIGURE_OUGING_EMAIL: "Email sent",
    EMAIL_SEND: "Email address",
    EMAIL_NAME_SEND: "Display Name",
    SERVER_MAIL_ADDRESS: "SMTP server",
    CONNECTOR: "SMTP port",
    ENCRYPTION_TYPE: "Secured connection",
    AUTHENTICATON_CONNECTION: "Authenticate Connection",
    EMAIL_TYPE: "Email type",
    TEST_EMAIL_SENT: "Test outgoing email",
    SENT_EMAIL_TEST: "Send test email",
    EMAIL_SETTING_EXISTED: "Email already exists",
    ERROR_MAIL: "Error",
    SUCCESS_MAIL: "Email sent successfully",
    UNIT_ROOM_PRICE: "Room rate",
    FROM_CHECKOUT: "From checkout",
    NON_REFUNDABLE: "Refundable",
    GUEST_NAME: "Guest name",
    FROM_TIME: "From",
    TO_TIME: "To",
    PROMOTION_CODE: "Promotion code",
    SORT: "Sort",
    HAS_CONNECTED: "Connected",
    GUEST: "Guest",
    COUPON_CODE: "Coupon code",
    PAYMENT_REQUIRED_UPON_BOOKING: "Payment required upon booking",
    CONDITIONS: "Conditions",
    HOW_MUCH_PAYMENT_IS_MADE_BY_THE_GUEST_ON_THE_DAY_OF_BOOKING: "How much payment did the guest make on the day of booking?",
    PERCENT_OF_TOTAL_ROOM_RATE: "% of total room rate",
    WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT_FOR_THE_REMAINING_AMOUNT: "When does the guest make the payment for the remaining amount?",
    WHAT_THE_PAYMENT_POLICY_FOR_THE_BOOKING_PERIOD: "For what set period does the payment policy apply?",
    WHAT_DOES_PAYMENT_POLICY_APPLY: "What stay period does the payment policy apply?",
    POLICY_SUMMARY: "Policy Summary",
    PERCENT_BOOKING: "% booking",
    WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT: "When does the guest make payment?",
    DATA_INPUT_MAX_24_HOUR: "Data cannot be older than 24 hours",
    DAY: "Date",
    HOUR: "Hour",
    HOW_MUCH_DOES_THE_CUSTOMER_MAKE_PAYMENT: "How much payment did the guest make?",
    ON_THE_DAY_OF_CHECK_IN: "On the check-in date",
    ON_THE_DAY_OF_CHECK_OUT: "On the check-out date",
    PRICE_PER_NIGHT: "Night rate",
    ON_THE_DATE_OF_BOOKING: "On the booking date",
    UPDATE_PRICE_NOTE: "Price and quantity data is overwritten. The Master Room rate updated will effect the child room rate",
    PROMOTION_TITLE: "Title",
    FREE_CANCELLATION_ALLOWED: "Allow free cancellation",
    HOW_LONG_BEFORE_CHECK_IN_CAN_GUESTS_CANCEL_FOR_FREE: "How long before check-in can guests cancel for free?",
    DAY_BEFORE_CHECK_IN: "{day} days before check-in",
    ACCORDING_TO_CUSTOM: "Customized",
    HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_THEY_CANCEL_A_RERVATION_DAYS_PRIOR_TO_ARRIVAL: "How much does a guest pay when they cancel a reservation within {day} days before arrival?",
    HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_CANCELING_A_RESERVATION: "How much does a guest have to pay when canceling a reservation?",
    WHAT_THE_CANCEL_POLICY_FOR_THE_BOOKING_PERIOD: "For what set period does the cancellation policy apply?",
    WHAT_DOES_CANCEL_POLICY_APPLY: "When does the cancellation policy apply?",
    HOW_MUCH_WILL_THE_CUSTOMER_HAVE_TOT_PAY_IF_THE_GUEST_CANCELS_ON_THE_CHECKIN: "How much will the customer have to pay if the guest cancels the reservation on the day of arrival?",
    UTC: "Time zone",
    ROOM_ARE_AVAILABLE_FROM_LESS_TO_MORE: "Room is available from less to more",
    TIME_ZONE_HOTEL: "Hotel time zone",
    BED_TYPE_SETTING: "Bed type setting",
    ROOM_TYPE_SETTING: "Room type setting",
    OVER_MAX_GUEST: "The maximum number of guests in an unsatisfied room type",
    OVER_MAX_ADULTS: "The maximum number of adults in the room type is not satisfied",
    OVER_MAX_CHILDREN: "The maximum number of children in the room type is not satisfied",
    OVER_MAX_BABY: "The maximum number of babies in the room type is not satisfied",
    UNDER_MAX_ADULTS: "The maximum number of adults in the sale package is not satisfied",
    UNDER_MAX_CHILDREN: "The maximum number of children in the sale package is not satisfied",
    UNDER_MAX_BABY: "The maximum number of babies in the sale package is not satisfied",
    UNDER_MAX_QUANTITY: "The total number of rooms cannot be greater than the declared availability",
    BOOKING_ENGINE: "Booking engine",
    TEXT_NOTIFY_EXPIRED: "Your account connecting the distribution channel to your {channel} channel has expired on {date}. The data will not be synced to the OTA channel, please renew",
    TEXT_NOTIFY_WILL_EXPIRE: "Your account connecting the distribution channel to the {channel} channel will expire on {date}. The data will not be synced to the OTA channel, please renew",
    ROOM_AND_PACKAGES_FOR_SALE_ON_GOOOGLE: "Rooms and packages for sale on google hotel channel",
    HOTEL_LOG_roomTypeI18n: "Room Type",
    HOTEL_LOG_lang: "Language",
    HOTEL_LOG_ratePlanI18n: "Room package",
    HOTEL_LOG_otaI18n: "OTA",
    BE_CONNECT_REQUIRED: "No Booking Engine connection yet",
    ACCESS_DENIED: "No access permission",
    OTA_NOT_FOUND: "OTA not found",
    HOTEL_SYNC: "The hotel has been synced",
    PASSWORD_SENT_SUCCESS: "Password sent successfully",
    CAN_NOT_DELETE: "Room type/Sale package has been connected to OTA",
    BOOKING_NOT_CANCEL: "Cannot cancel the reservation",
    HEADER_FOOTER_CONFIG: "Template",
    MENU_EDIT: "Menu type",
    MENU_NAME: "Name",
    MENU_CONFIG: "Menu display",
    WIDGETS_EDIT: "Widget type",
    ADD_NEW_WIDGETS: "Add new widget",
    WIDGETS_NOT_YET_DISPLAYED: "Widget not yet displayed",
    PARAMETERS: "Other setting",
    LOGO_DISPLAYS: "URL Logo",
    TOP_HEADER_BACKGROUND: "Header Top – Background colour",
    HEADER_BACKGROUND: "Header – Background colour",
    TEXT_HEADER_COLOR: "Header – Text colour",
    TEXT_HEADER_COLOR_ACTIVE: "Main color",
    FOOTER_BACKGROUND: "Footer – Background colour",
    TEXT_FOOTER_COLOR: "Footer – Text colour",
    BACKGROUND_COPYRIGHT: "Footer Bottom – Background colour",
    ADD_NEW_MENU: "Add new menu",
    CONTENT_WIDGETS: "Content",
    TITLE: "Title",
    REFERENCE_SAMPLE: "Reference sample",
    VI: "Vietnamese",
    EN: "English",
    BIGGER_THAN_EQUAL: "bigger than equal",
    AND_MORE: "and {count} other options",
    ALL_AGENT: "All agent",
    GROUP_AGENT: "Group agent",
    SPECIFIC_AGENT: "Specific agent",
    CHOOSE_NOT_APPLY_AGENT: "Select the agent does not apply promotion",
    CHOOSE_APPLY_AGENT: "Select the agent where the promotion applies",
    LIST_NOT_APPLY_AGENT: "The agent list does not apply for promotions",
    LIST_APPLY_AGENT: "List of agents where promotions apply",
    SEARCH_NAME_AGENT: "Enter the name or agent code",
    AGENT_TYPE: "type",
    ENTERPRISE_AGENT: "Enterprise travel",
    ENTERPRISE_TRADING: "Enterprise trading",
    ENTERPRISE_API: "Enterprise API",
    LIST_AGENT: "List Travel agent",
    SUCCESS: "Success",
    CONFIG_CONNECT: "Configure connection",
    NO_RECORDS: "There are no records to show",
    QUANTITY: "Quantity",
    ROOM_PRICE: "Room price",
    EXTRA_ADULT: "Extra Adult",
    EXTRA_CHILD: "Extra Child",
    HOTEL_PROMOTION: "Hotel promotions",
    GUEST_INFO: "Guest infomation",
    MAX_GUEST: "Number of guests",
    MAX: "Maximum",
    BOOKING_INFO: "General infomation",
    WRONG_DOMAIN: "Invalid domain name",
    FILE_NULL: "Error uploading file",
    PLEASE_COMPLETE_THE_FIELDS_MARKED: "Please fill out all required information fields",
    ADD_NEW_SOCIAL_NETWORK: "Add social network",
    PRIMARY_TEXT_COLOR: "Primary text color",
    PRIMARY_BACKGROUND_COLOR: "Primary background color",
    TOP_HEADER_TEXT_COLOR: "Top header text color",
    TOP_HEADER_BACKGROUND_COLOR: "Top header background color",
    HEADER_TEXT_COLOR: "Header text color",
    HEADER_BACKGROUND_COLOR: "Header background color",
    FOOTER_TEXT_COLOR: "Footer text color",
    FOOTER_BACKGROUND_COLOR: "Footer background color",
    BOTTOM_FOOTER_TEXT_COLOR: "Bottom footer text color",
    BOTTOM_FOOTER_BACKGROUND_COLOR: "Bottom footer background color",
    BUTTON_TEXT_COLOR: "Button text color",
    BUTTON_BACKGROUND_COLOR: "Button background color",
    BUTTON_TEXT_COLOR_2: "Button text color 2",
    BUTTON_BACKGROUND_COLOR_2: "Button background color 2",
    CUSTOM: "Custom",
    URL: "Link",
    OTA_IS_OUT_OF_TIME: "The OTA channel has not been activated yet",
    DATA_INPUT_MUST_BE_GREATER_THAN_0: "Input data must be greater than 0",
    HOTEL_EXTRA_RATE_UPDATE: "Update Surcharge Rate",
    HOTEL_EXTRA_RATE_DELETE: "Delete the surcharge",
    DATE_OF_STAY_DOES_NOT_APPLY: "Date of stay does not apply",
    DATE_OF_BOOKING_DOES_NOT_APPLY: "Set date does not apply",
    BOOKING_CODE_OTA: "OTA booking code",
    HOTEL_WAS_CONNECTED_WITH_OTA: "The hotel is already connected to the OTA channel",
    ROOM_TYPE_OTA: "ezCms Leo",
    CONNECTED: "Connected",
    NOT_CONNECTED: "Unconnected",
    MISSING_ROOM_AND_PRICE: "Missing rooms, rates and restrictions",
    CONNECTED_OTA: "OTA mapping",
    SYNC_IN_PROGRESS: "Synchronization is in progress",
    CONNECTING: "Connecting",
    ROOM_AND_PRICE_PACKAGES_HAVE_NOT_BEEN_DECLARED: "Room package and price have not been declared yet",
    CONNECTION_FAILED: "Connection failed",
    SU_CONNECTION: "Channel for sale",
    SU_MAPPING: "Mapping",
    CHANNEL_MANAGER_SYSTEM: "Central Reservation System",
    ENTER_NAME_OR_CODE: "Enter code or name",
    OTA_LOG: "Sync log",
    INVENTORY_LOG: "Inventory log",
    ERROR_LOG: "Error Log",
    SOURCE: "Source",
    UPDATE_TIME: "Updated Time",
    RATE: "Rate",
    STOP_SELL: "Stop sell",
    MIN_STAY: "Minimum stay date",
    MAX_STAY: "Maximum stay date",
    EXTRA_ADULT_RATE: "Additional charge for adults",
    EXTRA_CHILD_RATE: "Children's surcharge",
    FULL_UPDATE: "Details",
    UN_STOP_SELL: "Remove stop sell",
    OPEN_RESERVATION: "Open reservation",
    OPEN_CHECKOUT: "Open check-out",
    ERROR_PHONE_NUMBER_LENGTH: "Phone number must be at least 6 characters and up to 10 characters",
    ERROR_PHONE_NUMBER_STRING: "Phone number does not include letters and 0's at the beginning of the number",
    FAILURE: "Failure",
    ACTIVE_LOG: "Activity log",
    WAITING: "Ongoing",
    ROOM_SALE_UPDATE: "Update sales room",
    PRICE_EXTRA_SPECIAL: "Daily extra rate",
    BASE_PRICE_IS_MISSING: "No base price declared",
    TOOLTIP_MASTER: "Select 1 Master product line to use as a basis for calculating prices for the remaining lines",
    RULE_CODE: "Code between 2-20 characters containing only alphanumeric",
    ROOM_DERIVE: "Derive room - Derived from the parent roomtype",
    DERIVE_OF_ROOM: "Derived from",
    COPY_BY_FOMULAR: "Copy by fomular",
    PASTE: "Paste",
    DATE_RANGE: "About days",
    CODE_IS_EXISTED: "Service code already exists",
    HOTEL_CHANGE_SUCCESS: "Successful hotel change",
    ROOM_CLASS: "Room type",
    UPDATE_FOR: "Update for {date}",
    UPDATE_RATE_BY_RANGE: "Bulk update",
    BOOKER: "Booker name",
    SEARCH_BY_BOOKER: "Guest name",
    CONTACT_US: "Contact us",
    UPDATE_TO_STOP_SELLING_OPENING: "Update to stop selling/opening for sale",
    UPDATE_ROOM_AVAILABILITY_IN_STAGES: "Bulk update",
    UPDATE_SELLING_PRICES_IN_STAGES: "Update Rate",
    UPDATE_STOP_SELL: "Update stop sell",
    UPDATE_SELL_LIMIT_BY_OTA: "Update sell limit",
    UPDATE_SELL_LIMIT_FOR_NEW_OTA: "Update sell limit",
    UPDATE_RESTRICTION_STOPSELL: "Update stop sell",
    UPDATE_STOP_SELL_BY_OTA: "Update stop sell",
    DELETE_SELL_LIMIT_BY_OTA: "Delete sell limit",
    DELETE_STOP_SELL_BY_OTA: "Delete stop sell",
    OTHER_FUNCTION: "Others",
    VIEW_MOBILE_VERSION: "View as mobile device",
    VIEW_DESKTOP_VERSION: "View as desktop",
    FILTER_RESULTS: "Filter",
    STOPSELL_UPDATE_SUCCESS: "Update stopsell successfully",
    REMOVE_STOPSELL_SUCCESS: "Remove stopsell successfully",
    HOTEL: "0 Hotel | 1 Hotel | {count} Hotels",
    NIGHT_NUMBER: "Room night",
    CONFIRM_STOP_SELL: "Update stopsell",
    CONFIRM_REMOVE_STOP_SELL: "Apply remove stopsell",
    APP: "App",
    ENTER_THE_NAME_OF_THE_APP_WANT_TO_SEARCH_FOR: "Enter the name of the app you want to search for",
    LABEL_NIGHT_BACKGROUND_COLOR: "Sub background color 1",
    LABEL_NIGHT_TEXT_COLOR: "Subscript color 1",
    PACKAGE_TEXT_COLOR: "Sold package text color",
    PROMOTION_BACKGROUND_COLOR: "Secondary background color 2",
    PROMOTION_TEXT_COLOR: "Secondary Text Color 2",
    PRICE_TEXT_COLOR: "Price color 1",
    RANK_STAR_COLOR: "Star color",
    TEXT_PRICE_2_COLOR: "Cost color 2",
    SUB_TEXT_3_COLOR: "Additional text color 3",
    SUB_BACKGROUND_3_COLOR: "Sub background color 3",
    RE_SYNC: "Repost booking",
    CONFIRM_RE_SYNC: "Confirm repost",
    HOTEL_REPORT_BOOKING: "Repost booking",
    UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR: "1 update interval should not exceed 1 year",
    ACCOUNT_IS_NOT_CONNECTED_TO_GDS: "Account is not connected to ezCms GDS",
    DISCONNECT: "Disconnect",
    CONFIRM_DISCONNECT_OTA: "Are you sure you want to disconnect",
    CONFIRM_CONNECT_OTA: "Are you sure you want to reconnect",
    GDS_OTA: "ezCms GDS",
    ROOM_DUPLICATE: 'Room code cannot be duplicated',
    ROOM_PLAN_DUPLICATE: 'Rate code cannot be duplicated',
    YOU_DONT_HAVE_ANY_HOTELS_YET: "No hotels found.",
    TEXT_GDS_INFOMATION: "GDS is a worldwide computerized reservation network with over 450,000 TAs used to book hotel rooms.",
    ROOM_TYPE_ON_CMS: "Room type on ezCrs",
    ROOM_TYPE_ON_SABRE: "Room type on sale channel",
    ROOM_PLAN_ON_CMS: "Rate plan on ezCrs",
    ROOM_PLAN_ON_SABRE: "Rate plan on sale channel",
    CHAIN_CODE: "Hotel chain code",
    CHAIN_TYPE: "Type of hotel chain",
    ITEMS_SHOWING: "items displayed",
    TA_NAME: "Agent name",
    TA_CODE: "Agent code",
    CHAIN_TRAVEL_AGENT_INFOMATION: "Agent infomation",
    ASSIGN_TA_TO_HOTEL: "Assign travel agent to hotels",
    ALLOW_OVERWRITING_INFOMATION_DOWN_TO_THE_HOTEL: "Allows overwriting information down to the hotel",
    FIRST_NAME: "First name",
    LAST_NAME: "Last name",
    CHAIN_AGENT_LIST: "Company and Agent",
    ASSIGN_ROOM_TO_HOTEL: "Assign room to hotel",
    ASSIGN_RATE_PLAN_TO_HOTEL: "Assign room rate to hotel",
    CHAIN: "Chain",
    UNASSIGN: "Unassigned",
    ASSIGN: "Assigned",
    CONFIRM_CHANGE_ACTIVE: "Confirm agent status change",
    ENTERPRISE_CODE: "Enterprise code",
    FIRST_NAME_REPRESENT: "Representative last name",
    LAST_NAME_REPRESENT: "Name of representative",
    ACCOUNT_HOLDER: "Account Holder",
    POSITION: "Position",
    HOTEL_LIST: "List of hotels",
    CHAIN_CONFIG: "Chain Configuration",
    ASSIGN_SERVICE_TO_HOTEL: "Assign service to hotel",
    ROOM_TYPE_CODE_HAS_SYNCED_TO_OTA: "Hotel room class has been synced. Please check again",
    ROOM_CODE_DUPLICATION_ROOM_CODE_IN_CHAIN: "Room type code matches string room type code. Please check again",
    ROOM_CODE_DUPLICATION: "Room type code already exists",
    CHAIN_ROOM_TYPE_IS_OVER_LIMIT: "The number of rooms exceeds the total number of rooms at the hotel level",
    RATE_PLAN_CODE_DUPLICATION: "A sale package already exists. Please check again",
    SERVICE_NOT_EXIST: "Service does not exist",
    SERVICE_CODE_DUPLICATION: "Service code already exists in chain hotel. Please check again",
    TRAVEL_AGENT_ALREADY_EXIST: "Company information, agents already exist. Please check again",
    HOTEL_NOT_USE_EQUAL_CURRENCY: "The hotel assigned to use a different currency, please check again",
    AUTO_CANCEL: "Allow automatic cancellation if booking is not confirmed",
    ACCOUNT_IS_NOT_CONNECTED_TO_SITEMINDER: "Account is not connected to ezCms SiteMinder",
    ACCOUNT_IS_NOT_CONNECTED_TO_TRAVELOKA: "Account is not connected to ezCms Traveloka",
    ROOM_TYPE_MAP_UNMAP: "The currently connected room type will be disconnected if deselect and save is performed. This action may lead to loss of connection, overbooking, unmap booking.",
    OTA_HOTEL_CODE_ALREADY_EXITS: "The hotel code you entered has been connected, please check again!",
    ADD_SERVICE_TO_ROOM_RATE: "Add service to sale plan",
    CONFIRM_DELETE_SERVICE_PACKAGE: "Confirm removal of this service from the room rate",
    PACKAGE_DEAL: "Package deal",
    PACKAGE_ITEM: "Package item",
    PRICE_ALLOCATION: "Price Allocation",
    WEEKLY_PRICE: "Weekly rate",
    DAILY_PRICE: "Daily rate",
    RD_DAY: "{day}rd day",
    TOTAL_PACKAGE_VALUE: "Total package value",
    LIST_EDIT_SUCCESS: "Update success",
    INFOMATION_OF_BANK_ACCOUNT: "Information of bank's account",
    CHILD_HAS_MORE_OTA_THAN_MASTER: "Cannot create relationship",
    ENTIRE_HOTEL: "Hotel level",
    ACCORDING_TO_EACH_ROOM_CLASS: "Roomtype level",
    NUMBER_OF_ROOMS_AVAILABLE: "Number of rooms available",
    ROOM_OCCUPANCY: "Room occupancy",
    EDIT_DYNAMIC_PRICING: "Dynamic Pricing Template Details",
    ADD_NEW_DYNAMIC_PRICING: "Add new dynamic pricing model",
    DYNAMIC_PRICING: "Dynamic rate",
    CONFIRM_DELETE_DYNAMIC_PRICING: "Confirm delete dynamic price pattern",
    DYNAMIC_NAME: "Dynamic pricing model name",
    DYNAMIC_DESCRIPTION: "Description of dynamic price pattern",
    CRITERIA: "Criteria",
    PRICE_CALCULATION_FORMULA: "Price calculation formula",
    TOTAL_NUMBER_OF_ROOMS_BY_ROOM_CLASS: "Total number of sold rooms of room type (number of sold rooms of room type including Date of Use reservations)",
    TOTAL_NUMBER_OF_ROOMS_BY_HOTEL: "Total number of rooms sold by the hotel (number of rooms sold by the hotel including Day Use bookings)",
    TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_ROOM_CLASS: "Total number of rooms available by room type",
    TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_HOTEL: "Total number of hotel rooms available",
    ROOM_CAPACCITY_FORMULA: "Room capacity formula",
    FROM_TO_LESS: "From {val} to less than",
    NO_PRIOTITY: "No priority",
    PRIOTITY: "Priority",
    UN_SELECT_ALL: "Delete",
    SET_THE_PRICE_CYCLE: "Dynamic sale",
    EVENT: "By event",
    CALENDAR: "Schedule (Comming son)",
    DYNAMIC_RATE_METHOD: "Dynamic rate method",
    CONFIRM_DEACTIVE_DYNAMIC_RATE: "Confirmed to deactivate dynamic pricing",
    RMS_MANAGEMENT: "RMS",
    DERIVED_ROOMTYPE: "Derived roomtype",
    BASE: "Base roomtype",
    UPDATE_FORMULAR: "Update formula",
    FORMULAR: "Formula",
    SET_UP_FORMULAR_BY_DATE_RANGE: "Set up formula by date range",
    MASTER_RATE: "Master rate",
    SET_UP_FORMULAR: "Set up formula",
    CONFIRM_DELETE_FORMULA: "Confirm delete formula",
    EDIT_PRICE: "Edit price",
    FOR_EXAMPLE_SERVICE: "Booking from October 1 to October 10 (9 nights) <br> With custom configuration: <br> <ul> <li> Starting from 1st night: 1 </li> <li> Ends on th night: Last night </li> <li>Use cycle: 2 (days)</li> <li> Number of repetitions: 3 (times)</li></ul > Service can be applied from October 1 to October 10. <br> Since the usage cycle is 2 (2 days/time), the service can be applied on October 1st. , 3/10, 5/10, 7/10, 9/10.<br> But because the number of iterations is 3, the service applied for 3 days is 1/10, 3/10, 5/10.<br > With the above configuration, the service will be applied on <strong>1/10, 3/10, 5/10</strong>",
    SCHEDULINGTYPE_1: "Applies to the first night of stay",
    SCHEDULINGTYPE_2: "Applies to the last night of stay",
    SCHEDULINGTYPE_3: "X night applies 1 time, starting from night Y",
    SCHEDULINGTYPE_4: "Applies to all nights except the first",
    SCHEDULINGTYPE_5: "Applies to all nights except the last",
    SCHEDULINGTYPE_6: "Not applicable for the first and last night",
    SCHEDULINGTYPE_7: "Applies to nights (14 nights)",
    SCHEDULINGTYPE_8: "Apply arbitrary X nights",
    SCHEDULINGTYPE_9: "Custom",
    SCHEDULINGTYPE_0: "All Nights",
    EXAMPLE: "Example",
    STARTING_FROMM_NIGHT: "Starting night",
    ENDS_ON_NIGHT: "Ending night",
    USE_CYCLE: "Cycle of use",
    NUMBER_OF_REPETITION: "Number of repetitions",
    NUMBER_OF_REPETITION_DETAIL: "Using cycle (X nights applied 1 time)",
    NIGHT_14_DESCRIPTION: "If booking over 14 nights, after 14 nights the service will be applied again according to the selected cycle",
    CODE_NOT_EMPTY: "Code cannot be duplicated or blank",
    BEFORE_THE_LAST_NIGHT: "Before the last night",
    LAST_NIGHT: "Last Night",
    CONFIRM_UPDATE_PRICE_SERVICE_GREATER_THAN_TOTAL_PACKAGE: "The allocation price is greater than the total package price. Do you confirm the update?",
    EDIT_ATTRIBUTION: "Edit attribution",
    MIN_ROOM_RATE: "Minimum room rate",
    SETUP_FORMULA: "Update formula",
    SETUP_FORMULA_BY_DATE_RANGE: "Update formula by date range",
    DELETE_FORMULA: "Delete Formula",
    CAN_NOT_CREATE: "Unable to create room sale because it depends on parent room sale",
    HAVE_BEEN_CONNECTED_TO_OTA: "Room Class/Package has been connected to OTA",
    CAN_NOT_INACTIVE_OR_DELETE: "Unable to update",
    ROOM_RATE_IS_CHILDREN: "The product is updating is the derived product",
    TO_LESS: "to less than",
    COMBO: "Package",
    TITLE_DESCRIPTION_DYNAMIC_CHANGE: "The change method by event allow the hotel to configure to change dynamic rate/ restriction by event which related to inventory including:",
    CHANGE_TYPE_1: "Inventory updated from PMS",
    CHANGE_TYPE_2: "Bookings pushed / pulled from the online channels",
    CHANGE_TYPE_3: "Activate / Deactivate room type",
    CHANGE_TYPE_4: "Create / Modify Dynamic Rate Formula",
    CHANGE_TYPE_5: "Change room rate",
    CHANGE_TYPE_6: "Close / Open the room",
    SCHEDULE_DYNAMIC_PRICING: "Dynamic room sale configuration",
    HAVE_BEEN_CONNECTED_TO_DYNAMICPRICING: "Can not delete as the product set up Dynamic Rate",
    SERVICE_INCLUDES: "Service includes",
    CHAIN_INFO: "General Information - Chain",
    CHAIN_ROOM_TYPE: "Room Type - Chain",
    CHAIN_RATE_PLAN: "Room Package - Chain",
    CHAIN_ROOM_TYPE_AMENITY: "Room Utility - Chain",
    CHAIN_SERVICE: "Service - Chain",
    CODE_NOT_VALIDATE: "Code not validate",
    PAYMENT_CODE: "Payment code",
    PAYMENT_TYPE: "Transaction Type",
    PAYMENT_STATUS: "Transaction Status",
    PAYMENT: "Payment",
    REFUND: "Refund",
    CANCELLATION_REFUND: "Cancellation refund",
    CANCELLATION_FEE: "Cancellation fee",
    WAITING_PAYMENT: "Pending",
    SUCCESS_PAYMENT: "Success",
    FAILED: "Failure",
    CHAIN_NOT_EXIST: "Chain not exist",
    CHAIN_TRAVEL_AGENT: "Company and agent information - Chain",
    HOTEL_TRAVEL_AGENT: "Company and agent information",
    BE_MANAGEMENT: "ezBe",
    THE_SYSTEM_IS_LOADING: "The system is loading, please wait",
    OTA_HOTEL_NOT_FOUND: "OTA hotel not found",
    ROOM_CLASS_MAPING: "Connection Room Type",
    CONFIRM_SAVE: "You have just changed the connection information. This action may result in loss of connection, unmap and overbooking",
    UNDO: "Undo",
    CONFIRM_UNDO: "The changes you just made will not be saved, are you sure you want to do the undo",
    DEFAULT_LANGUAGE: "Main language used",
    RE_SYNC_CONNECT: "Re-sync",
    ez_FOLIO: "ezFolio",
    ez_CLOUDHOTEL: "ezCloudHotel",
    ADVANCE_SEARCH: "Advance search",
    PRICE_OR_OTA_IS_REQUIRED: "Sell price or sales channel cannot be empty",
    UPDATE_BY_ROOM_TYPE: "Update by room type",
    UPDATE_BY_SALE_PACKAGE: "Update by room rate",
    UPDATE_BY_SALE_CHANNEL: "Update by OTA channel",
    BULK_DELETE: "Bulk delete",
    CONFIRM_UPDATE_OVERWRITE: "Update confirmation overrides price and number of people included in the price for all selected sales channels",
    ONLY_UPDATE_PRICE: "Price override only",
    DAILY_MASTER_RATE: "Derived daily rate",
    NUMBER_NIGHT: 'nights',
    NUMBER_ROOM: "Rooms",
    ROOM_CAP: "0 room | 1 room | {count} rooms",
    BOOKING_CAP: "0 booking | 1 bookings | {count} bookings",
    CHECKIN_STATUS_RESERVED: "Reserved",
    CHECKIN_STATUS_CHECKIN: "Check in",
    CHECKIN_STATUS_CHECKOUT: "Check out",
    CHECKIN_STATUS_NO_SHOW: "No show",
    CHECKIN_STATUS_ARRIVAL: "Arrival",
    CHECKIN_STATUS_DUE_OUT: "Due Out",
    CHECKIN_STATUS_CANCELLED: "Cancelled",
    NAME_OF_GUEST_STAYING: "Staying guest",
    PRICE_EXTRA_DAILY: "Daily extra rate",
    CHANNEL: "0 channel | 1 channel | {count} channels",
    ASSIGN_RATE_TO_CATEGORY: "Assign rate plan to catalog",
    _CATEGORY: {
        CODE: "Category Code",
        NAME: "Category Name",
        DESCRIPTION: "Description"
    },
    ASSIGN_HOTEL_TO_CATEGORY: "Assign category to hotel",
    CHAIN_REGIS_INFO: "Chain registration information",
    CONFIRM_DELETE_RATE_CATEGORY: "Confirmation to delete rate category",
    RATE_CATEGORY_ALREADY_EXIST: "The rate category already exists",
    RATE_PLAN_DOES_NOT_EXIST: "Rate plan does not exist",
    CANCEL_REASON: "Reason for cancellation",
    RATE_PMS: "PMS selling price",
    ALL_PLAN: "All rate plan",
    ALL_RATE_CATEGORY: "All rate category",
    TO_PAGE: "List from 1 to {count}",
    ASSIGN_ROOM_TYPE: "Room assignment",
    CONFIG_RATE_OTA: "OTA Rate Configuration",
    CONFIG_RATE_PMS: "PMS Rate Configuration",
    UPDATE_RATE_PMS: "Update price",
    VIEW: "View",
    CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE_PMS: "The selected period price will be deleted in other room types and sale packages. <br>Are you sure you want to remove the staged price?",
    WAITING_UPDATE: "Data has been recorded and is in process",
    STATUS_ROOM_TYPE_ON_OTA: "Connection status on OTA",
    BOOKING_LIST_GROUP: "Group booking",
    _GROUP_STATUS: {
        HOLD: "Hold",
        TENTATIVE: "Tentative",
        CONFIRMED: "Confirmed",
        CANCELED: "Canceled",
        CHECKED_IN: "Checked in",
        CHECKED_OUT: "Checked out",
        CLOSE: "Closed",
        NO_SHOW: "No show"
    },
    _BOOKING_GROUP: {
        BOOKING_GROUP_NAME: "Name of group reservation",
        BOOKING_GROUP_CODE: "Group reservation code",
        GROUP_PROFILE_NAME: "Group profile name",
        GROUP_PROFILE_CODE: "Group Profile Code",
        BOOKING_GROUP_START_DATE: "Start Date",
        BOOKING_GROUP_END_DATE: "End Date",
        BOOKING_GROUP_CREATE_DATE: "Creation time",
        STATUS: "Group Status",
    },
    ENTER_TEXT: "Enter {text}",
    LIST_PROFILE_GROUP: "List of group records",
    PROFILE_GROUP: "Group Profile",
    SEARCH_BY_PROFILE_NAME_AND_CODE: "Search by profile name or profile code, email, address",
    BOOKINGS_GROUP: "Number of group bookings",
    PROFILE_NUMBER: "{count} records",
    _GROUP: {
        CONFIRM_DELETE: "Confirm deletion of group records",
        DETAIL: "Details of Team Profile",
        INFO: "Profile Information",
        INFO_MANAGE: "Management information",
        ASSIGN: "Assign delegation",
        GROUP_PROFILE_NAME: "Profile Name",
        GROUP_PROFILE_NAME_OTHER: "Other name",
        COMPANY_NAME: "Company / Agent Name",
        DESCRIPTION: "Description",
        CONTACT_NAME: "Name of the representative",
        PHONE_NUMBER: "Phone number",
        PHONE_NUMBER_OTHER: "Other phone number",
        MANAGE_NAME: "Manager's first and last name",
        DETAIL_BOOKING: "Group booking details",
        GROUP_INFO: "Group Information",
        LEADER: "Leader",
        PMS_CCODE: "PMS Code",
        CUS_OF_DAYS: "Cut off days",
        CUT_OF_DATE: "Cut off date",
        PAYMENT_INFO: "Payment Information",
        TOTAL: "Total amount",
        UPDATE_PROFILE: "Update crew profile",
        PAYMENT_METHOD: "Payment method",
        PAYMENT_METHOD_BOOKING_RETAIL: "Individual payment method",
        BOOKING_GROUP_INFO: "Group booking information",
        LEADER_NOT_PAY: "Leader does not pay",
        LEADER_PAY_ONE_PART: "Party payment leader",
        LEADER_PAYS_ALL: "Full payment union field",
        CHOOSE_PROFILE: "Select the union profile",
        TITLE: "Title"
    },
    ROOM_OF_LEADER: "Room leader",
    NUMBER_OF_BOOKING: "Number of bookings",
    SUB_BOOKING_CODE: "Sub-Group Code",
    UPDATE_INFO_BOOKING_GROUP: "Update group booking file information",
    ALLOW_OVERWRITING_INFOMATION_DOWN: "Allow information overwriting",
    FILTER: "Filter",
    GROUP_PROFILE: "Group profile",
    BOOKING_GROUP_PROFILE: "Booking group",
    ASSIGN_HOTEL: "Hotel assignment",
    ASSIGN_ROOM_TO_CATEGORY: "Assign room to category",
    UPDATE_ROOM_RATE_PMS: "Configuring PMS Rates",
    UPDATE_ROOM_RATE_OTA: "Configuring OTA Rates",
    BOOKING_UNMAP: "Unmap Booking",
    CONFIRM_DELETE_ROOM_CATEGORY: "Confirmation of deleting room category",
    CHAIN_ROOM_CATEGORY_ALREADY_EXIST: "Chain room category already exists",
    ROOM_CATEGORY_ALREADY_EXIST: "Room category already exists",
    ASSIGN_OTA: "Channel assignment",
    NOTE_ASIGN_OTA: "Note: The sale channel will be automatically assigned to the selected room categories and synced to the hotel that has subscribed to the channel if you press save",
    ACTION_TIME: "Update Time",
    PROCESS_TIME: "Processing Time",
    IGNORE: "Ignore",
    RESEND: "Reupdate",
    LIST_ACTION_PROCESS: "Incomplete actions",
    STATUS_PROCESSING: "In progress",
    STATUS_FAILED: "Failed",
    STATUS_DONE: "Done",
    UPDATE_RATE: "Update rate",
    UPDATE_RATE_SPECIAL: "Update daily rate",
    UPDATE_EXTRA_RATE: "Update extra rate",
    UPDATE_EXTRA_SPECIAL_RATE: "Update daily extra rate",
    UPDATE_AVAIL: "Update availability",
    UPDATE_RESTRICTION: "Update restriction",
    PROCESS_CAP: "0 processes | 1 process | {count} processes",
    CONFIRM_IGNORE: "The error operation will not perform the update again. Are you sure you want to select skip",
    HOTEL_BOOKING_UNMAP_REPOST: "Repost booking",
    UPDATE_RESTRICTION_MINSTAY: "Update minstay",
    UPDATE_RESTRICTION_MAXSTAY: "Updating maxstay",
    UPDATE_RESTRICTION_MINSTAYARRIVAL: "Update minstay arrival",
    UPDATE_RESTRICTION_MAXSTAYARRIVAL: "Update maxstay arrival",
    UPDATE_RESTRICTION_MINBOOKINGWINDOW: "Update min booking window",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOW: "Update max booking window",
    UPDATE_RESTRICTION_EXACTSTAY: "Update exactstay",
    UPDATE_RESTRICTION_EXACTSTAYARRIVAL: "Update exactstay arrival",
    UPDATE_RESTRICTION_CLOSEDONARRIVAL: "Update does not allow check-in",
    UPDATE_RESTRICTION_CLOSEDONDEPARTURE: "Update does not check out",
    UPDATE_RESTRICTION_CLOSED: "Updates stopped selling",
    DELETE_PRICE_SPECIAL: "Delete daily rate",
    DELETE_EXTRA_RATE: "Delete Surcharge",
    DELETE_EXTRA_SPECIAL_RATE: "remove daily surcharge",
    HOTEL_DASHBOARD_IGNORE_TASK: "Ignore",
    HOTEL_DASHBOARD_REUPDATE_TASK: "Reupdate",
    CHAIN_ROOM_UPDATE_QUANTITY: "Update number of rooms",
    ROOM_UPDATE_QUANTITY: "Update number of rooms",
    CHAIN_ROOM_CATEGORY: "Room category - Chain",
    HOTEL_ROOM_CATEGORY: "Room category",
    HOTEL_RATE_CATEGORY: "Room category",
    CHAIN_RATE_CATEGORY: "Rate category - Chain",
    ERROR_CAUSE: "Error cause",
    INVENTORY_NOT_SYNC: "Empty rooms are not synced",
    UNKNOWN_ERROR: "Unknown error",
    BY_RATE: "According to fixed price",
    BY_FORMULA: "According to the formula",
    CONFIG_TYPE: "Configuration Type",
    FOMULA_FROM_TO: "Formula to calculate prices from Monday to Sunday",
    CONFIRM_DEACTIVE_DYNAMIC_RESTRICTION: "Confirmation of deactivation of flexible restriction",
    EDIT_DYNAMIC_RESTRICTION: "Flexible Limited Template Insights",
    ADD_NEW_DYNAMIC_RESTRICTION: "Add new flexible restriction template",
    DYNAMIC_RESTRICTION: "Dynamic restriction",
    CONFIRM_DELETE_DYNAMIC_RESTRICTION: "Flexible restriction pattern deletion confirmation",
    DYNAMIC_RESTRICTION_NAME: "Flexible Restricted Template Name",
    DYNAMIC_RESTRICTION_DESCRIPTION: "Description of flexible restriction pattern",
    RESTRICTION_CALCULATION_FORMULA: "Configuration Information",
    NO_CHANGE: "No change",
    ADULT_CAP: "0 adults | 1 adult | {count} adults",
    CHILD_CAP: "0 children | 1 child | {count} children",
    BABY_CAP: "0 babies | 1 baby | {count} babies",
    USE_MODEL: "Set as model",
    ADD_RANGE: "Add range",
    MODEL_DESCRIPTION_RESTRICTION: "price/price formula/capacity range/restrictions will be copied down to the room types and sale packages below if selected.",
    MODEL_DESCRIPTION_PRICE: "price/price formula/capacity range/restrictions will be copied down to the room types and sale packages below if selected.",
    NOTE_ROOM_RATE: "B: Room rates for the respective room type. Room rates are displayed and updated at the room sales screen. When creating a new room rate is taken by default from the room rate in the room type",
    DYNAMIC_SALE: "Dynamic room sale",
    NOTE_MODEL_PRICE: "Users can edit room types that are copied from the template",
    ACCOUNT_UPDATE: "Updated account",
    ITEMS_PER_PAGE: "Rows per page",
    UPDATE_RATE_SPECIAL_FROM_CHAIN: "Update rate from chain",
    EQUIVALENT_TO_ROOM_NIGHT: "Equivalent to room night",
    CREATED_BY_ACCOUNT: "Created by account",
    IS_LEGACY_ROOM_CLASS: "Can not delete as the roomtype and rate plan is derived",
    ASSIGN_RATE_CATEGORY: "Assign rate category",
    ASSIGN_ROOM_CATEGORY: "Assign room category",
    CUSTOMER_PHONE: "Customer's phone number",
    CUSTOMER_MAIL: "Email of customer order",
    DU_DESCRIPTION_OF_ROOM_TYPE: "Day Use Bookings of room type (Bookings with arrival date = departure date)",
    DU_DESCRIPTION_OF_HOTEL: "Hotel Day Use Bookings (Bookings with arrival date = departure date)",
    OVERVIEW: "Overview",
    INDEX_P: "Occupancy (P)",
    INDEX_P_ROOM: "Capacity by room type",
    INDEX_P_HOTEL: "Occupancy by hotel",
    INDEX_A: "Number of rooms sold (including Day Use) (A)",
    INDEX_B: "Number of rooms available for sale (B)",
    INDEX_DU: "Number of rooms sold (Day Use) (DU)",
    INDEX_INV: "Room available",
    BY_ROOM: "By room type",
    BY_HOTEL: "By hotel",
    DYNAMIC_NAME_HAS_EXIST: "Dynamic name already exists",
    ROOM_SALE_WITH_ROOM_TYPE: "View room type",
    ROOM_SALE_WITH_OTA: "View by channel",
    ROOM_FUND: "Alotment",
    NODATA_2: "Please enter more than 2 characters",
    CHOOSE_MARKET_SEGMENT: "Choose market segment",
    MARKET_SEGMENT: "Market Segment",
    TRAVEL_AGENT_SPEC: "Specific agent",
    SEGMENT_SPEC: "Specific market segment",
    SHOW_CARD_PAYMENT_INFO: "Manage payment card information",
    ENTER_TO_SEARCH_MORE: "Enter to search more",
    EMAIL_ACCESSTOKEN: "Email to receive card information access code",
    TEXT_NOTIFY_EXPIRED_GROUP_OTA: "The {channel} function has expired on {date}",
    TEXT_NOTIFY_WILL_EXPIRE_GROUP_OTA: "The {channel} function will expire on {date}",
    PLEASE_RENEW: ". Please contact via email <u>hotro@ezcloud.vn</u> or hotline <u>1900 9013</u> for support.",
    NOTIFY_OFF_MODULE: "The function of Selling rooms by room type will stop working in the near future. Please send all your comments to the mailbox <b>hotro@ezcloud.vn</b>",
    NEW_MESSAGE: "New message",
    PAXONE: "Price for 1 person",
    PAXTOW: "Price for 2 people",
    PAXEXTRA: "Price per extra person",
    MAP_PRODUCT: "Assign product",
    UPDATE_RESTRICTION_BY_RATE_PLAN: "Update restriction",
    CREATE_RESTRICTION: "Create restriction",
    DELETE_ROOM_RATE: "Delete room rate",
    UPDATE_SPECIAL_RATE: "Update daily rate",
    HERE: "here",
    ACCESS_TOKEN_EMAIL_IS_NOT_EMPTY: "Please add email to receive card information",
    ADD_PROGRAM: "Add program",
    TYPE_APPLY_PROMOTION: "Promotion system",
    PROMOTION_CHARCE_COUPON: "Promotion, discount code",
    PROMOTION_CHARGE: "Promotion applies",
    COUPON_APPLY: "Discount code applies",
    EZ_PROMOTION_NOT_SUPPORTED_PROMOTION_TYPE: "The ezPromotion system does not support this type of promotion",
    ERROR_EZ_PROMOTION: "Unable to connect to ezPromoion system",
    CANCEL_PROMOTION_ERROR: "Promotion cancellation failed",
    CONFIRM_PROMOTION_ERROR: "Promotion confirmation failed",
    RELOAD: "Refresh",
    WARNING: "Warning",
    TXT_WARNING_OVER: "To ensure system performance, no more than 50 lines should be updated per operation. Thank you!",
    CONFIRM_DELETE_DATA_ENTERED: "You have just made a change to the master product. Do you want to delete the price data you just entered?",
    ROOM_STATUS_1: "Booked",
    ROOM_STATUS_2: "Checked in",
    ROOM_STATUS_3: "Checked out",
    ROOM_STATUS_4: "Noshow",
    ROOM_STATUS_5: "Cancelled",
    BOOKING_HISTORY: "Booking history",
    BOOKING_STATUS_OTA: "Booking status from OTA",
    BOOKING_OTA_STATUS_0: "New booking",
    BOOKING_OTA_STATUS_1: "Modified booking",
    BOOKING_OTA_STATUS_2: "Cancelled booking",
    BOOKING_OTA_STATUS_3: "Forwarding booking",
    COPY_RATE: "Duplicate rate plan",
    SALE_PACKAGE_CODE_NEW: "New rate plan code",
    SELLING_PACKAGE_NEW: "New rate plan name",
    DUPLICATE: "Duplicate",
    SALE_PACKAGE_CODE_OLD: "Old rate plan code",
    FAST_UPDATE: "Fast update",
    AUTO_CANCEL_PAYMENT_FAIL: "Allow automatic cancellation if payment booking fails, after",
    EZPAYREF: "Reference code",
    TOOLTIP_AUTO_CANCEL_PAYMENT_FAIL: "If this function is enabled, after a booking is in the Payment Failed status for a configured period of time, ezCrs will automatically cancel those bookings. The default time in the first setting is 30 minutes. If left blank, the applied value is 0 minutes.<br> Note: Cancellation time may be a few minutes slower depending on the connection.",
    TOOLTIP_AUTO_CANCEL: "For reservations that require prepayment by a specific date, upon receipt of payment/deposit by the customer in non-recordable ezCrs forms such as cash or bank transfer, the hotel must confirm that reservation. If this function is enabled, ezCrs will automatically cancel unconfirmed reservations for that day. Automatic cancellation dates for reservations will be set in the payment policy and applied according to each rate policy.",
    CONFIG_BY: "Set by",
    LIST_FORMULAR: "List of formulas",
    ROOM_TYPE_BASE: "Base room type",
    SALE_PACKAGE_BASE: "Base price policy",
    SALE_CHANNEL_BASE: "Base sales channel",
    ROOM_TYPE_DERIVED: "Derive room type",
    SALE_PACKAGE_DERIVED: "Derive rate plan",
    SALE_CHANNEL_DERIVED: "Derive sales channel",
    HOTEL_LOG_derivationType: "Recipe type",
    HOTEL_LOG_formulaType: "Type",
    HOTEL_LOG_master: "Master",
    HOTEL_LOG_children: "Child",
    HOTEL_LOG_formula: "Formula",
    HOTEL_ROOM_TYPE_SPECIAL: "Update room rates",
    UPDATE_ROOM_TYPE: "Update room type",
    TOOLTIP_BASE_ROOM_TYPE: "Only the products of room types within the derivative type that share the same rate plan and sales channel as the product of room type {value} will be derived accordingly based on the formula.",
    TOOLTIP_BASE_RATE_PLAN: "Only the products of rate plans within the derivative rate plan that share the same room type and sales channel as the product of rate plan {value} will be derived accordingly based on the formula.",
    TOOLTIP_BASE_OTA: "Only the products of sales channels within the derivative channel that share the same rate plan and room type as the product of sales channel {value} will be derived accordingly based on the formula.",
    VALUE_AND_PERSON_IS_REQUIRED: "Price and number of guests cannot be empty",
    PLS_CHOOSE_ONE_SELECT_BOX: "Please select at least 1 'delete' box to update",
    NOTE_DERIVED: "The new derrived fomular will override the previous fomular if if it matches in either the derived or base product",
    ROOM_QUANTITY_PARENT_NOT_SAME: "The number of roomtype in the parent and child room must be equal to be able to create",
    IS_REDIRECTING: "Is redirecting",
    MAP: "Map",
    SYNC_FROM_PRICELABS: "Sync from Pricelabs",
    HOTEL_EXTRA_SPECIAL_RATE_DELETE: "Delete daily extra rate",
    HOTEL_EXTRA_SPECIAL_RATE_UPDATE: "Update daily extra rate",
    SYNC_DATA_TO_OTA: "Sync data to ota",
    MODULE_EZ_PAYMENT_NOT_ACTIVE: "Module ezPayment is not active",
    NOT_DELETE_ROOM_TYPE_CODE_HAS_SYNCED_TO_OTA: "Cannot delete the roomtype which connecting with OTA",
    ENABLE_SYNC_NOT_UPDATED: `The roomtype is currently connected with OTAs. Please follow the below steps  to be able to change the number of guests in the roomtype as changes may affect the connection.<br><br>\
    <span class="font-weight-bold">Step 1:</span> Access Sync Management => select ezCms vela+ => choose the OTA Mapping tab and disconnect the room type you would like to change from all connected OTA channels.<br>\
    <span class="font-weight-bold">Step 2:</span> Select the Channels tab and proceed to disconnect the room type you want to change.<br>\
    <span class="font-weight-bold">Step 3:</span> Change the number of guests and reconnect the OTA channels.<br><br>\
    <span class="font-weight-bold">Note:</span> Please follow the steps in the correct order to avoid connection errors that could lead to revenue loss.<br>\
    Find details at <a href="https://help.ezcms.vn/tich-hop-he-thong-ezcms-vela/" target="_blank"><u>here</u></a>`,
    ENABLE_SYNC_NOT_CREATED: `The roomtype code is already exists at the hotel level, it  cannot be changed due to its connection with the OTA. \
    Please change the room type code or adjust the number of guests in the chain or at the hotel for this roomtype.`,
    UNDERSELL_LIMIT_TITLE: "Set the available room threshold for channels to control room sales. When the number of available rooms on that channel reaches or falls below this threshold, the stop-sell action will be triggered.",
    SELL_LIMIT_TITLE: "Set the maximum room limit for channel groups to control room sales and optimize revenue.",
    ROOM_FOR_SALE: "Rooms for sale",
    NO_CHANNEL_GROUP: "Please select the channel group to update",
    DATA_BLANK: "Input data can not be blank",
    ROOM_QUANTITY_PARENT_NOT_SAME: "The number of roomtype in the parent and child room must be equal to be able to create",
    VALUE_MUST_BE_LESS_THAN_24H: "The value must be less than 24H",
    N_O: "N.O",
    MASTER_ROOM_TYPE: "Master roomtype",
    MASTER_RATE_PLAN: "Master rate plan",
    MASTER_CHANNEL: "Master channel",
    DERIVED_ROOM_TYPE: "Derived roomtype",
    DERIVED_RATE_PLAN: "Derived rate plan",
    DERIVED_CHANNEL: "Derived channel",
    MASTER_PRODUCT: "Master product",
    FORMULAR_LIST: "Formular list",
    DERIVED_PRODUCT: "Derived product",
    PRICE_FORMULA: "Price formular",
    SELECT_TYPE: "Select type",
    SHOW_MORE_FOMULA: "Show more fomular",
    SELECT_TYPE_RESTRICTION: "Select type of restriction",
    SETUP_FORMULAR_LIST: "Set up formular list",
    APPLY_DATE: "Applied date",
    LIST_FROM: "Listing from",
    TO: "to",
    IN: "in",
    NO_TYPE_SELECTED: "Select rate or any type of restriction to create the formular",
    ROOM_TYPE_NOT_MATCH: " There is no formular can be set up as the rate plan or channel is not matching between base and derived products. Please double check or create the corresponding product.",
    SALE_PACKAGE_NOT_MATCH: "There is no formular can be set up as the roomtype or channel is not matching between base and derived products. Please double check or create the corresponding product.",
    SALE_CHANNEL_NOT_MATCH: "There is no formular can be set up as the rate plan or roomtype is not matching between base and derived products. Please double check or create the corresponding product.",
    CUSTOM_NOT_MATCH: "The formula has not been established due to the incompatibility of the master and child product in terms of room type, rate plan or channel.",
    CHANGE: "Change",
    CURRENT_FORMULA: "Current formula",
    NEW_FORMULA: "Created formula",
    MODIFIED_FORMULA: "Modified formula",
    DELETED_FORMULA: "Deleted formula",
    DERIVED: "Derived",
    LIST_FORMULAR_UPDATE: "Updated formula",
    BEFORE: "Before",
    AFTER: "After",
    ROOM_RATE_DERIVATIONS_NOT_FOUND: "Room rate derivations not found",
    UPDATE_RESTRICTION_MINBOOKINGWINDOWBYHOUR: "Update min booking window by hour",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOWBYHOUR: "Update max booking window by hour",
    UPDATE_RESTRICTION_SALEINVENTORY: "Update rooms for sale",
    UPDATE_RESTRICTION_SELLLIMIT: "Update sell limit",
    NUMBER_OF_DAYS: "Number of days",
    NUMBER_OF_HOURS: "Number of hours",
    REMOVE_DAYLY_RATE: "Remove daily rate",
    ALLOW_CHECKIN: "Allow check-in",
    ALLOW_CHECKOUT: "Allow check-out",
    QUICK_UPDATE: "Update type",
    BASE_PRICE_REQUIRED: "Please update the weekly rate first",
    CALENDAR_ROOM: "Calendar view",
    DATA_BLANK: "Input data can not be blank",
    WARNING_EMAIL: "Email",
    SAFE_PRICE_RANGE: {
        PROTECTION_RATE: "Protection rate",
        PROTECTION_RATE_TOOLTIP: "Protection rate is the rate range which will not be allowed to save if the input data in roomsell less than set up minimum rate or higher than maximum rate ",
        MINIMUM_RATE: "Minimum rate",
        MAXIMUM_RATE: "Maximum rate",
        MINIMUM_RATE_INVALID: "The minimum rate can not be higher than maximum rate",
        MAXIMUM_RATE_INVALID: "The maximum rate can not be lower than minimum rate",
        PROTECTION_RATE_INPUT_INVALID: "Input value can not be less than {priceMin} or higher than {priceMax}",
        MINIMUM_RATE_INPUT_INVALID: "Input value can not be less than {priceMin}",
        MAXIMUM_RATE_INPUT_INVALID: "Input value can not be higher than {priceMax}",
    },
    PRICE_OUT_OF_BOUND: "Input rate exceeded the protection rate",
    ROOM_TYPE_ON_SABRE_DUPLICATE: "Room type on sale channel cannot be duplicated",
    ROOM_PLAN_ON_SABRE_DUPLICATE: "Rate plan on sale channel cannot be duplicated",
    PRICE_UPDATE_OUT_OF_BOUND: "Current selling rate exceeded the protection rate",
    INCLUDED_TAX: "Included tax",
    ACTIVATE: "Activate",
    NO_RANK: "No rank",
    ONE_STAR: "1 star",
    TWO_STAR: "2 stars",
    THREE_STAR: "3 stars",
    FOUR_STAR: "4 stars",
    FIVE_STAR: "5 stars",
    EXAMPLE_INFO: `<p><i><u><span>Example:</span></u></i></p>
    <p>The hotel is using the currency: <span>VND</span></p>
    <p>Deluxe room has a declared price: <span>900.000</span></p>
    <p>Rate: <span>0.00005</span></p>
    <p>Price difference: <span>0.5</span></p>
    <p>Then the price of Deluxe rooms on OTA channels after synchronization will be :<span>(900.000 x 0.5) + 0.5 = 50 $</span></p>`,
    FREE_SALE_ALLOTMENT: "Free sale allotment by Cut of date",
    ACTIVITY_LOG: "0 log | 1 log | {count} logs",
    TIPS: "Tips",
    _CONFIGURATION: {
        MENU: "Menu",
        WIDGET: "Widget",
        THEME: "Theme",
        SCRIPT: "Script",
        MENU_HEADER: "Menu Header",
        MENU_FOOTER: "Menu Footer",
        LOGO: "Logo",
        HEADER: "Header",
        BE_CONTENT: "BE Content",
        FOOTER: "Footer",
        FOOTER_BOTTOM: "Footer Bottom",
        FOOTER_RIGHT: "Footer Right",
        WIDGET_FOOTER_RIGHT: "Widget Footer Right",
        WIDGET_FOOTER_BOTTOM: "Widget Footer Bottom",
        WIDGET_SOCIAL_MEDIA_ICON: "Widget: Social Media Icon",
        WIDGET_HTML_TEXT: "Widget: HTML Text",
        SCRIPT_WILL_ADD_BODY: "The scripts will be printed in the <body>",
        SCRIPT_WILL_ADD_HEAD: "The scripts will be printed in the <head>",
        TEMPLATE: "Template",
        BODY: "Body",
        BE_SUPPORT: `<p class="fs-14"><b>METHOD 1: Integration using pre-made form</b></p>
        <p>This feature allows you to integrate the Booking Engine with your website, specifically displaying the Booking Engine's booking form on your website.</p>
        <img src="/script-BE.png">
        <br>
        <p><b>Step 1:</b> Copy the HTML code below and place it where you want the booking form to appear on your website.</p>
        <div>
            <i>&lt;div class="booking-form"&gt;&lt;/div&gt;</i>
        </div>
        <div class="mt-3">
            <p><b>Step 2:</b> Copy the script below and place it in the footer of your website (before the closing body tag).</p>
            <p> 1. If your website does not have jquery:</p>
            <i> &emsp;&lt;script src="https://apps.oneinventory.com/plugins/ezbe-chain-jquery-5s.js"&gt;&lt;/script&gt; <br>
            &emsp;&lt;script&gt;<br>
            &emsp;&emsp;create_booking_form('XXXXXX', '.booking-form', 'vi', 'VND', 'horizontal', '#ffffff', '#fc5b62');<br>
            &emsp;&lt;/script&gt;<br></i>
        </div>
        <div class="mt-3">
            <p>2. If your website already has jquery (in case of script conflicts):</p>
            <i>&emsp;&lt;script src="https://apps.oneinventory.com/plugins/ezbe-chain-5s.js"&gt;&lt;/script&gt; <br>
            &emsp;&lt;script&gt; <br>
            &emsp;&emsp;create_booking_form('XXXXXX', '.booking-form', 'vi', 'VND', 'horizontal', '#ffffff', '#fc5b62'); <br>
            &emsp;&lt;/script&gt; <br></i>
        </div>
        <br>
        <p><b>Step 3:</b> Customize the parameters in the <b>create_booking_form</b> function to be compatible with your website before saving.</p>
        <p class="mb-1"><b>In which:</b> </p>
        <div class="ml-3">
            <p class="mb-1"><i>XXXXXX</i> : Your hotel code (required).</p>
            <p class="mb-1"><i>.booking-form</i> : The id (#) or class (.) of the HTML element where the form will be placed, as declared in Step 1 (required).</p>
            <p class="mb-1"><i>vi</i> : The language code (optional). Supports 2 codes:</p>
                <p class="mb-1 ml-5"><i>vi</i> : Vietnamese</p>
                <p class="mb-1 ml-5"><i>en</i> : English</p>
            <p class="mb-1"><i>VND</i> : The currency unit code displayed in the Booking Engine, following international currency code standards (optional).</p>
            <p class="mb-1"><i>horizontal</i>: The form display style (customizable). Supports 2 styles:</p>
            <p class="mb-1 ml-5"><i>horizontal</i>: Horizontal display</p>
            <p class="mb-1 ml-5"><i>vertical</i>: Vertical display</p>  
            <p class="mb-1"><i>#ffffff</i> : The color code for the "Find Room" button text (optional).</p>
            <p class="mb-1"><i>#fc5b62</i> : The background color code for the "Find Room" button (optional).</p>
        </div>
        <hr>
        <p class="fs-14"><b>METHOD 2: Integration using URL link</b></p>
        <p>Assign the URL to a button or a hyperlink. Use the following sample URL:</p>
        <div>
            <i>https://booking.ezcms.vn/hotel/BeDetailHotel?hotel_code=XXXXXX&check_in=2020-11-30&check_out=2020-12-01&num_of_rooms=1&num_of_adults=2&num_of_children=0&promo_code=&rate_code=&room_code=&lang=vi&amp;currency=VND</i>
        </div>
        <br>
        <p class="mb-1"><b>In which:</b> </p>
        <div class="ml-3">
            <p class="mb-1"><i>hotel_code</i>: Your hotel code (required)</p>
            <p class="mb-1"><i>check_in</i>: The check-in date, in YYYY-MM-DD format (optional)</p>
            <p class="mb-1"><i>check_out</i>: The check-out date, in YYYY-MM-DD format (optional)</p>
            <p class="mb-1"><i>num_of_rooms</i>: The number of rooms (optional)</p>
            <p class="mb-1"><i>num_of_adults</i>: The number of adults (optional)</p>
            <p class="mb-1"><i>num_of_children</i>: The number of children (optional)</p>
            <p class="mb-1"><i>room_code</i>: The room type code (optional)</p>
            <p class="mb-1"><i>rate_code</i>: The rate policy code (optional)</p>
            <p class="mb-1"><i>promo_code</i>: The promo code (optional)</p>
            <p class="mb-1"><i>lang</i> : The display language code (optional)</p>
            <p class="mb-1"><i>currency</i> : The display currency unit code (optional)</p>
        </div>
        <hr>
        <p class="fs-14"><b>METHOD 3: Direct integration into the hotel's website</b></p>
        <p>This feature allows you to integrate the Booking Engine with the website. Specifically, it displays the room booking list from the Booking Engine on the hotel’s website.</p>
        <p class="mb-3">
            <b>Step 1:</b> Copy the sample HTML snippet below and place it where you want to display the booking form on your website. <br/>
            <i>&lt;div class="booking-form"&gt;&lt;/div&gt;</i>
        </p>
        <p class="mb-3">
            <b>Step 2:</b> Copy the sample script below and place it in the website footer (before the closing body tag).<br/>
            <i> &emsp;&lt;script src="https://app.oneinventory.com/booking-engine/plugins/ezbe-embed.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;window.initBookingForm({<br>
                &emsp;&emsp;&emsp; hotel: [{ hotelName: 'Hotel A', hotelCode: 'KSA' }],<br> 
                &emsp;&emsp;&emsp; target: '.booking-form',<br>
                &emsp;&emsp;&emsp; path: '/room-list',<br>
                &emsp;&emsp;&emsp; lang: 'vi',<br>
                &emsp;&emsp;&emsp; background: '#ffffff',<br>
                &emsp;&emsp;&emsp; buttonBackground: '#ff0000',<br>
                &emsp;&emsp;&emsp; buttonTextColor: 'white',<br>
                &emsp;&emsp;&emsp; textColor: '#333333'<br>
                &emsp;&emsp; });<br>
                &emsp;&lt;/script&gt;<br>
            </i>
        </p>
        <p class="mb-0">
            <b>Step 3:</b> Customize the parameters in the <b>window.initBookingForm</b> function to match the hotel’s website before saving.
        </p>
        <div class="ml-3">
            <p class="mb-0"><b>Details:</b></p>
            <p class="mb-1">
                - <i>hotel</i>: List of hotels. Can be one or multiple hotels, each hotel is defined as one object (required).<br/>
                <span style="padding-left: 12px;"><i>hotelName</i>: Hotel name.</span><br/>
                <span style="padding-left: 12px;"><i>hotelCode</i>: Hotel code.</span><br/>
            </p>
            <p class="mb-1">
                - <i>target</i>: ID (#) or class (.) of the HTML element declared in Step 1 (required).
            </p>
            <p class="mb-1">
                - <i>path</i>: Path to the page displaying the room list. If not provided, it will default to the BE page <code>https://booking.ezcms.vn</code> (optional).
            </p>
            <p class="mb-1">
                - <i>lang</i>: Language to display in the form and room list. If not set, it will default to Vietnamese (optional).<br/>
                <span style="padding-left: 12px;"><b>Supports 7 languages:</b></span><br/>
                <span style="padding-left: 12px;"><i>vi</i>: Vietnamese</span><br/>
                <span style="padding-left: 12px;"><i>en</i>: English</span><br/>
                <span style="padding-left: 12px;"><i>ja</i>: Japanese</span><br/>
                <span style="padding-left: 12px;"><i>ko</i>: Korean</span><br/>
                <span style="padding-left: 12px;"><i>lo</i>: Lao</span><br/>
                <span style="padding-left: 12px;"><i>km</i>: Khmer</span><br/>
                <span style="padding-left: 12px;"><i>zh</i>: Chinese</span><br/>
                <span style="padding-left: 12px;"><b>Note: </b> If the selected language is not configured on the Booking Engine page, the room list will default to English.</span>
            </p>   
            <p class="mb-1">
                - <i>background</i>: Background color of the form. Default: #eee (optional).
            </p>
            <p class="mb-1">
                - <i>buttonTextColor</i>: Text color of the "Search Room" button. Default: #fff (optional).
            </p>
            <p class="mb-1">
                - <i>buttonBackground</i>: Background color of the "Search Room" button. Default: red (optional).
            </p>
            <p class="mb-1">
                - <i>textColor</i>: Text color inside the form. Defaults to browser's default (optional).
            </p>  
        </div>
        <p class="mt-3 mb-0">
            <b>Step 4:</b> On the page displaying the hotel's room list (as configured in the path of Step 3)
        </p>
        <p class="mb-0">
            Copy the sample HTML snippet below and place it where you want to display the room list.<br/>
            <i>&lt;div id="room-list"&gt;&lt;/div&gt;</i>
        </p>
        <p class="mb-3">
            Copy the sample script below and place it in the website footer (before the closing body tag).<br/>
            <i> &emsp;&lt;script src="https://app.oneinventory.com/booking-engine/plugins/ezbe-embed.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;window.initBookingEngine({<br>
                &emsp;&emsp;&emsp; target: '#room-list',<br>
                &emsp;&emsp;&emsp; scrollToTop: true,<br>
                &emsp;&emsp;&emsp; marginTop: 0<br>
                &emsp;&emsp;});<br>
                &emsp;&lt;/script&gt;<br>
            </i>
        </p>
        <p class="mb-0">
            <b>Step 5:</b> Customize the parameters in the <b>window.initBookingEngine</b> function before saving.
        </p>
        <div class="ml-3">
            <p class="mb-0"><b>Details:</b></p>
            <p class="mb-1">
                - <i>target</i>: ID (#) or class (.) of the HTML element declared in Step 4 (required).
            </p>
            <p class="mb-1">
                - <i>scrollToTop</i>: Displays a scroll-to-top icon when the page scrolls down over 500px. Clicking it scrolls back to the top. Default is false (optional).
            </p>
            <p class="mb-1">
                - <i>marginTop</i> : Creates spacing from the top. The purpose is to prevent content from being hidden by a fixed element above, such as a fixed header on a website (optional).
            </p>
        </div>
        <p style="margin-top: 10px;"><b>See demo page </b><a href="https://app.oneinventory.com/booking-engine" target="_blank">here</a></p>`,
    },
    CONFIRM_TRANET_CONNECT: `{roomConfirm} exceeded the maximum occupancy-18 pax, if you click Map the error <span class="font-weight-bold">fail mapping</span> may happen. Please double check.`,
    _PROMOTION: {
        MEALS: {
            BREAKFAST: "Breakfast",
            LUNCH: "Lunch",
            DINNER: "Dinner",
        },
        PROMOTION_TYPE_LIST: {
            EVERY_NIGHT: "Every night",
            TOTAL_BOOKING: "Total booking value",
            ORDER_BEFORE: "Order x days before check-in date",
            ORDER_WITHIN: "Order within x days before check in",
            FREE_QUANTITY: "Order quantity x, free quantity y",
            FREE_ON_TOTAL_VALUE: "Order quantity x, free y on the total value",
        },
        DISCOUNT_LIST: {
            DISCOUNT: "Discount",
            SURCHARGE: "Surcharge",
        },
        TARGET_APPLY_LIST: {
            BY_AGENT_LEVEL: "By agent level",
            BY_AGENT: "By agent",
        },
        LEVEL_TARGET_APPLY: {
            LEVEL_1: "Level 1",
            LEVEL_2: "Level 2",
            LEVEL_3: "Level 3",
            LEVEL_4: "Level 4",
            LEVEL_5: "Level 5",
        }
    },
    UTM_CODE: "UTM Code",
    ZOOM: "Zoom",
    UPDATE_FAILED: "Update failed",
    DELETE_FAILED: "Delete failed",
    CREATE_FAILED: "Create failed",
    UPLOAD_FAILED: "Upload failed",
    USER_NOT_RIGHT: "No permission",
    USER_NOT_EXIST: "Account does not exist",
    EMAI_IS_EXIST: "Email already exists",
    ACTIVE_SUCCESS: "Active success",
    DEACTIVE_SUCCESS: "Unlink successful",
    TODAY: "Today",
    YESTERDAY: "Yesterday",
    TOMORROW: "Tomorrow",
    LOGIN_FAILED: "Login failed",
    ONEPAY_INLAND: "OnePay inland",
    ONEPAY_OVERSEA: "OnePay overseas",
    VN_PAY: "VN Pay",
    SUN: "SUN",
    MON: "MON",
    TUE: "TUE",
    WED: "WED",
    THU: "THU",
    FRI: "FRI",
    SAT: "SAT",
    UNDER_MAX_GUEST: "The number of guests exceeds the maximum allowed under the pricing policy",
    SAVE_RESULTS_WHEN_MAKING_CHANGES: "Save the results after making changes",
    $vuetify: {
        badge: 'Badge',
        close: 'Close',
        dataIterator: {
            noResultsText: 'No matching records found',
            loadingText: 'Loading items...'
        },
        dataTable: {
            itemsPerPageText: 'Rows per page:',
            ariaLabel: {
                sortDescending: 'Sorted descending.',
                sortAscending: 'Sorted ascending.',
                sortNone: 'Not sorted.',
                activateNone: 'Activate to remove sorting.',
                activateDescending: 'Activate to sort descending.',
                activateAscending: 'Activate to sort ascending.'
            },
            sortBy: 'Sort by'
        },
        dataFooter: {
            itemsPerPageText: 'Items per page:',
            itemsPerPageAll: 'All',
            nextPage: 'Next page',
            prevPage: 'Previous page',
            firstPage: 'First page',
            lastPage: 'Last page',
            pageText: '{0}-{1} of {2}'
        },
        datePicker: {
            itemsSelected: '{0} selected',
            nextMonthAriaLabel: 'Next month',
            nextYearAriaLabel: 'Next year',
            prevMonthAriaLabel: 'Previous month',
            prevYearAriaLabel: 'Previous year'
        },
        noDataText: 'No data available',
        carousel: {
            prev: 'Previous visual',
            next: 'Next visual',
            ariaLabel: {
                delimiter: 'Carousel slide {0} of {1}'
            }
        },
        calendar: {
            moreEvents: '{0} more'
        },
        input: {
            clear: 'Clear {0}',
            prependAction: '{0} prepended action',
            appendAction: '{0} appended action'
        },
        fileInput: {
            counter: '{0} files',
            counterSize: '{0} files ({1} in total)'
        },
        timePicker: {
            am: 'AM',
            pm: 'PM'
        },
        pagination: {
            ariaLabel: {
                wrapper: 'Pagination Navigation',
                next: 'Next page',
                previous: 'Previous page',
                page: 'Goto Page {0}',
                currentPage: 'Current Page, Page {0}'
            }
        },
        rating: {
            ariaLabel: {
                icon: 'Rating {0} of {1}'
            }
        },
        loading: 'Loading...'
    },
    DAYS_OF_WEEK: {
        SUN: "Su",
        MON: "Mo",
        TUE: "Tu",
        WED: "We",
        THU: "Th",
        FRI: "Fr",
        SAT: "Sa",
    },
    URL_INVALID: "URL is not valid",
    SELECT_ROOM_TYPE: "Select room type",
    OTA_CONNECTION_ERROR: "OTA connection error",
    ROOM_RATE_TYPE: "Room type {room} rate plan {rate}",
    NOT_MATCH_GUEST_COUNT: "Number of guests mismatch between ezCrs and Traveloka",
    STAFF_MANAGEMENT: "Staff management",
    FUNCTION_MANAGEMENT: "Function management",
    SETUP_RATE_TYPE: "Set up rate type sent to CM from channel",
    INCLUDE_COMMISSION: "Include commission",
    EXCLUDE_COMMISSION: "Exclude commission",
    UNDEFINED_COMMISSION: "Undefined",
    EXTRA_DATA_TO_OTA: "Set up rate type sent to CM from channel",
    ROOM_TYPE_SYNCED: "The roomtype mapped with OTA, please double check.",
    MANDATORY_LANGUAGE_REQUIRED: "Vietnamese and English languages are required.",
    TOOLTIP_TOGGLE_LANGUAGE: "When changing the display language, please make sure to update all multilingual fields as well — for example, room type names, policy names, etc.",
    TOOLTIP_INCLUDE_COMMISSION: `
        <span class="font-weight-bold fs-13">- Configuration: Exclude commission</span> – The ezCrs system will recalculate the room rate for reservations where the channel collects payment, if sufficient data is available.<br/>
        <span class="font-weight-bold fs-13">- Configuration: Include commission</span> – The ezCrs system will keep the room rate value exactly as sent by the channel.<br/>
        <span class="font-weight-bold fs-13">- Configuration: Undefined</span> – Used when the system cannot determine whether the rate sent by the channel already includes commission or not.
        In this case, both fields <span class="font-weight-bold fs-13">Include commission</span> and <span class="font-weight-bold fs-13">Exclude commission</span> will be marked as <span class="font-weight-bold fs-13">Undefined</span>.`,
    TOOLTIP_INCLUDE_COMMISSION_AGODA: `
        <span class="font-weight-bold fs-13">- Configuration: Include commission</span> – The ezCrs system will recalculate the room rate for reservations if sufficient data is available.<br/>
        <span class="font-weight-bold fs-13">- Configuration: Exclude commission</span> – The ezCrs system will keep the room rate value exactly as sent by the channel.<br/>
        <span class="font-weight-bold fs-13">- Configuration: Undefined</span> – Used when the system cannot determine whether the rate sent by the channel already includes commission or not. In this case, both fields
        <span class="font-weight-bold fs-13">Include commission</span> and <span class="font-weight-bold fs-13">Exclude commission</span> will be marked as <span class="font-weight-bold fs-13">Undefined</span>.`,
    INPUT_INVALID: "Exceeded maximum quantity",
    GOOGLE_NOTE: "<strong>Note:</strong> According to Google’s latest regulations, hotels using Google Hotel are required to update <strong>tax and fee</strong> data. The system must include <strong>at least one tax or fee with a value greater than 0</strong> to ensure data validity and prevent errors.",
    INVOICE_REQUEST: "Invoice request",
    COMPANY_NAME_OR_BOOKER: "Company name/Booker",
    HIDE_INFORMATION: "(Hide information)",
    SHOW_INFORMATION: "(View information)",
    MODULE_EZ_PROMOTION_NOT_ACTIVE: "Module promotion is not active",
    INCLUDE_COMMISSION_RATE: "Include commission rate",
    EXCLUDE_COMMISSION_RATE: "Exclude commission rate",
    COMMISSION_RATE_NOTE: "Note: The include and exclude commission data is for reference only",
    SETUP_RATE_TYPE_NOTE: "Note: The configuration change for “Rate settings sent to CM from the channel” can only be performed when the system has at least one (01) room type successfully connected to the corresponding channel.",
};